import React, { useState, Component, createRef } from "react";
import PopUpItem from "../PopUp/PopUpItem";
import PopupArcode from "../PopUp/PopUpArcode";
import PopUpOther, { CreditCode, SERIALNUMBER } from "../PopUp/PopUpOther";
import PopUpSearchDoc, { ReDate } from "../PopUp/PopUpS_Cscustorder";
import PopUpSaveMoney from "../PopUp/PopUpSaveMoney";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { parseJwt } from "../parseJWT";
import PopUpReport from "../PopUp/_fromShow";
import PopUpSelSaleRef3 from "../PopUp/PopUpSelSaleRef3";
import PopUpwarehouse from "../PopUp/PopUpwarehouse";
import "./../_css/App.css";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { MenuItem, Button, Modal, Row, Col, Panel } from "react-bootstrap";
import { checkData } from "../_source/checkDatainput";
import { checkunit } from "../_source/checkUnit";
import axios from "axios";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
import Checkdocgroup from "../CustomFunction/Docgroup/Checkdocgroup";
import CheckAr from "../CustomFunction/Csar/GetAr";
import CheckUser from "../CustomFunction/Csuser/GetUser";
import CheckBrabchname from "../CustomFunction/Branch/Checkname";
import CheckDepartmentname from "../CustomFunction/Department/Checkname";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import Gendocno from "../CustomFunction/Docno/GetDocno";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import cheackprice from "../CustomFunction/Product/ChackPrice";
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
  genURLTEST,
} from "./../_getjson";
import Checkdocno from "./../CustomFunction/Docno/GetDocno";
import Checknamecupon from "../CustomFunction/Checkcupon/Checkname";
import CheckTaxrate from "./../CustomFunction/Docgroup/CheckTaxrate";
import Checkstock from "./../CustomFunction/Product/ChkStock";
import SelectDatas from "./../PopUp/SelectData";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from "../PopUp/FullScreendialogs/FullScreen";
import CustomInputtext from "./../Components/CustomInput/Inputtext";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Moment from "moment";
import Checkmaingroup from "../CustomFunction/Product/Checkmaingroup";
import PopupCsardeposit from "./../PopUp/FullScreendialogs/Components/PopupCsardeposit";
import Checkwarehousepermission from "./../CustomFunction/STKwarehouse/Checkwarehousepermission";
import CustomInput from "../Components/CustomInput/CustomInput";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FullScreenDialognew from "../Components/CustomDialogs/Fullscreendialog";
import Repostview from "../Components/Reportview/Repostview";
import Salewithholding from "../PopUp/Salewithholding";
import Rechecked from "./component/Rechecked";
import CheckCodeDocGroup from "../CustomFunction/Docgroup/CheckCodeDocGroup";

const rowTable = 300;
const defaultcode = "0";
//
//const reporturl = "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FSALESlip&standAlone=true"
const listmenu = [
  ["เลือกเอกสารอ้างอิง", "SelSaleRef3"],
  ["หักเงินมัดจำ", "Csardeposit"],
  ["ภาษีถูกหัก ณ ที่จ่าย", "Salewithholding"],
  ["บันทึกรับเงิน", "SaveMoney"],
];
export default class Sale extends Component {
  constructor(props) {
    super(props);
    this.CustomerCode = createRef();
    this.CustomerName = createRef();
    this.Groupdata_code = createRef();
    this.Groupdata = createRef();
    this.DeliNumber = createRef();
    this.TaxNumber = createRef();
    this.CreditCode_code = createRef();
    this.CreditCode = createRef();
    this.Csuser_code = createRef();
    this.Csuser = createRef();
    this.Department_code = createRef();
    this.Department = createRef();
    this.SumPrice = createRef();
    this.Branch_code = createRef();
    this.Branch = createRef();
    this.Discountinput = createRef();
    this.Discount = createRef();
    this.depositpayment = createRef();
    this.WTAXAMOUNT = createRef();
    this.ProductValue = createRef();
    this.REMARK = createRef();
    this.TaxPersen = createRef();
    this.TaxPrice = createRef();
    this.valueTax = createRef();
    this.Check_Status = createRef();
    this.Deposit_No = createRef();
    this.ValueExcept = createRef();
    this.TotalPrice = createRef();
    this.ArCode2 = createRef();
    this.interest = createRef();
    this.downpayment = createRef();
    this.period = createRef();
    this.commissionfee = createRef();
    this.contractfee = createRef();
    this.coupon = createRef();
    this.FreeGift = createRef();
    this.pdinumber = createRef();
    this.mileageNumber = createRef();
    this.machineNumber = createRef();
    this.MTSerialNo = createRef();
    this.Rnregist = createRef();
    this.carinsurance = createRef();

    this.state = {
      _saveStatus: "",
      TBLastClick: -1,
      C1_editable: false,
      Show_SERIALNUMBER: false,
      siteCodeUser: "", // สาขาพนักงาน
      creditType: "", //สถานะเครดิต
      EventType: "",
      Typeofcar: "",
      deprositState: 0,
      address: "",
      SaleType: "0",
      _srefdoctype: "0",
      Groupdata: "",
      Groupdata1: "",
      Bonus: "0",
      Claim: "0",
      handleClose: false,
      show1: false,
      autoClose: 4800,
      Groupdata_txt: "",
      Department_txt: "",
      Branch_txt: "",
      ARSUBGROUP: "",
      isLoading: false,
      messagealert: "",
      openBackdrop: false,
      SelSaleRefopen: false,
      provenance: "",
      PriceType_code: defaultcode,
      defaultselect: defaultcode,
      CheckKilometer: "",
      selectclaim: false,
      selectgiveaway: false,
      checkenableInput: [],
      defaultwarehouse: "",
      defaultlocetion: "",
      PROJECT: "",
      defaultvaluewarehouse: "",
      //หักเงินมัดจำ
      tbCsardeposit: "",
      sumsapdeposit: 0,
      // from
      mid: "",
      reporturl: "",
      formPrintdata: "",
      withholdingData: [],
      withholdingdefaultValue: [],
      receivedwithholdingdevalue: 0,
      ressale: [],
    };
    //const { id } = useParams();
    //const id = useParams()
  }
  /* เช็คข้อมูลตรงกับตารางหรือไม่ตรง */
  onClickDocNo = async () => {
    if (!this.state.DOCGROUP_code) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" });
    }
    if (this.state.DOCGROUP_code) {
      //Checkdocno
      await Checkdocno(this.state.DOCGROUP_code, "CSSALE")
        .then(async (result1) => {
          if (result1 !== undefined) {
            this.DeliNumber.current.value = await result1;
          } else {
            this.DeliNumber.current.value = "";
          }
        })
        .catch((err) => {
          this.DeliNumber.current.value = "";
          console.log(err);
        });
    } else {
      this.DeliNumber.current.value = "";
    }
  };
  onKeyDown = (e) => {
    console.log("onKeyDown", e.target.name);
    if (e.key === "Enter") {
      if (e.target.name === "Groupdata") {
        this.onAddValue("Groupdata", e.target.value, false);
      }
      if (e.target.name === "CustomerCode") {
        this.onAddValue("CustomerCode", e.target.value);
      }
      if (e.target.name === "Department") {
        this.onAddValue("Department", e.target.value);
      }
      if (e.target.name === "Branch") {
        this.onAddValue("Branch", e.target.value);
      }
    }
  };
  onClick = (e) => {
    if (e.target.value !== "") {
      switch (e.target.name) {
        case "Groupdata":
          this.Groupdata.current.value = this.Groupdata_code.current.value;
          break;
        case "Department":
          this.Department.current.value = this.Department_code.current.value;
          break;
        case "Branch":
          this.Branch.current.value = this.Branch_code.current.value;
          break;
        default:
          break;
      }
    }
  };
  onChange = (e) => {
    switch (e.target.name) {
      case "Department":
        if (e.target.value === "") {
          this.setState({ Department_txt: "" });
          this.state.Department_txt = "";
        }
        break;
      case "Branch":
        if (e.target.value === "") {
          this.setState({ Branch_txt: "" });
          this.Branch_code.current.value = "";
        }
        break;
      case "Groupdata":
        if (e.target.value === "") {
          this.setState({ Groupdata_txt: "" });
          this.Groupdata_code.current.value = "";
          this.DeliNumber.current.value = "";
          this.TaxNumber.current.value = "";
        }
        break;
      case "CustomerCode":
        if (e.target.value === "") {
          this.CustomerCode.current.value = "";
          this.CustomerName.current.value = "";
        }
        break;
      default:
        break;
    }
  };
  onBlur = (e) => {
    if (e.target.name === "Groupdata") {
      this.Groupdata.current.value = this.state.Groupdata_txt;
    }
    if (e.target.name === "Department") {
      this.Department.current.value = this.state.Department_txt;
    }
    if (e.target.name === "Branch") {
      this.Branch.current.value = this.state.Branch_txt;
    }
  };

  async componentDidMount() {
    //เช็คเปิดปิด textbox

    await this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });

    console.log("hostname", window.location.hostname);
    this.setState({
      provenance: window.location.hostname === "localhost" ? "" : "Web",
    });

    this.MTSerialNo.current.value = "";
    //------------------------------------------ get setcode user ---------------------------------------------
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({
      siteCodeUser: SITECODESTR.User.SITECODE,
      // ,
      // defaultvaluewarehouse: SITECODESTR.User.SITECODE
    });
    this.setState({ userCode: SITECODESTR.User.CODE });
    //------------------------------------------- set table ---------------------------------------------------
    this.setRow(rowTable);

    this.onAddValue("Csuser", SITECODESTR.User.CODE);
    this.onAddValue("Branch", SITECODESTR.User.SITECODE);
    this.TaxPersen.current.value = "7.00";

    this.Csuser.current.value = localStorage.getItem("UsernameTH");
    setTimeout(() => {
      this.Cal_Price();
    }, 80);
    let mid = new URLSearchParams(location.search).get("mid");
    this.loadFromindb(mid);
  }
  loadFromindb = async (mid) => {
    //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ
    //console.log("res.data", mid)
    let url = `reportmanage/reportform/${mid}?`;
    //console.log("res.data", genURL(url))
    let res = await axios.get(genURL(url));
    if (res.data.length > 0) {
      await this.setState({ reporturl: res.data[0].pathname });
      await this.setState({ formPrintdata: res.data });
    }
  };
  escapeRegExp(str) {
    return str.replace(/,/g, " ");
  }
  saveData = async (
    CashReceipt,
    BOOKNO,
    BANKAMOUNT,
    BANKEXPEND,
    BOOKDESC,
    Remakcase,
    Bill,
    Billsum,
    Credit,
    Creditsum,
    Income,
    Incomesum,
    Expenses,
    Expensessum,
    // เพิ่มเติม
    arrayBill,
    arrayCredit,
    arrayexpenses,
    arrayotherincome
  ) => {
    // console.log("arrayBill");
    // console.log(arrayBill);
    //console.log("arrayCredit");
    // console.log(arrayCredit);
    // console.log("arrayotherincome");
    // console.log(arrayotherincome);
    // console.log("arrayexpenses");
    // console.log(arrayexpenses);
    let DEBTBALANCE;
    if (this.state.creditType === "C00") {
      DEBTBALANCE = "0.00";
    } else {
      DEBTBALANCE = this.TotalPrice.current.value;
    }
    // return;
    const parameter = new URLSearchParams();
    var dataTT = [];
    var s = [];
    var C4Send;
    var C3Send;
    // เช็คข้อมูลในตาราง
    for (
      let i = 0;
      i < this.state.products.length && this.state.products[i].productcode;
      i++
    ) {
      console.log("xxxxx", this.state.products[i]);
      C4Send =
        typeof this.state.products[i].location !== undefined
          ? this.state.products[i].location
          : "";
      C3Send =
        typeof this.state.products[i].warehouse !== undefined
          ? this.state.products[i].warehouse
          : "";
      dataTT[i] = {
        Productcode: this.state.products[i].productcode,
        Productname: this.escapeRegExp(this.state.products[i].productname),
        Warehouse: C3Send,
        Location: C4Send,
        Unitcode: this.state.products[i].unitcode,
        Quantity: this.state.products[i].quantity,
        Saleprice: this.state.products[i].saleprice,
        Discountword: this.state.products[i].discountword,
        Discountamount: this.state.products[i].discountamount,
        Refdocno: this.state.products[i].refdocno,
        Stocktype: this.state.products[i].stocktype.toString(),
        RefLineID:
          typeof this.state.products[i].refLineID !== "undefined"
            ? this.state.products[i].refLineID.toString()
            : "",
        Amount: this.state.products[i].amount,
        Unitname: this.state.products[i].unitname,
        Itemtaxtype: this.state.products[i].itemtaxtype.toString(),
        Productset:
          typeof this.state.products[i].productset !== "undefined"
            ? this.state.products[i].productset.toString()
            : "",
        Parentcode:
          typeof this.state.products[i].parentcode !== "undefined"
            ? this.state.products[i].parentcode.toString()
            : "",
        Productgroup:
          typeof this.state.products[i].productgroup !== "undefined"
            ? this.state.products[i].productgroup.toString()
            : "",
      };
      s.push(dataTT[i]);
    }
    // console.log("sssssssss",s);
    //  return
    /* Success */
    parameter.append("listitem", JSON.stringify(s));
    parameter.append(
      "withholdingData",
      JSON.stringify(this.state.withholdingData)
    );
    //หักเงินมัดจำ
    var datadeposit = [];
    var s1 = [];
    var rowdeposit = this.state.tbCsardeposit;
    console.log(rowdeposit);
    var BATHDEPOPAY1 = 0;
    var SUMPAYAMOUNT = 0;
    for (var i = 0; i < rowdeposit.length && rowdeposit[i].DEPOSITNO; i++) {
      SUMPAYAMOUNT += Number(rowdeposit[i].PAYAMOUNT);
      BATHDEPOPAY1 += Number(rowdeposit[i].NOVAT);
      datadeposit[i] = {
        ALLOCATECODE: rowdeposit[i].ALLOCATECODE, //0
        PAYAMOUNT: rowdeposit[i].PAYAMOUNT, //1
        DEBTBALANCE: rowdeposit[i].DEBTBALANCE, //2
        DEPARTMENT: rowdeposit[i].DEPARTMENT, //3
        DEPOSITNO: rowdeposit[i].DEPOSITNO, //4
        DOCDATE: Moment(rowdeposit[i].DOCDATE, "YYYY-MM-DD").format(
          "YYYY-MM-DD"
        ), //5
        EXCHANGERATE: rowdeposit[i].EXCHANGERATE, //6
        ISTAX: rowdeposit[i].ISTAX.toString(), //7
        NOVAT: rowdeposit[i].NOVAT, //8
        PROJECT: rowdeposit[i].PROJECT, //9
        REMARK: rowdeposit[i].REMARK, //10
        SELFLAG: rowdeposit[i].SELFLAG, //11
        SITECODE: rowdeposit[i].SITECODE, //12
        TAXRATE: rowdeposit[i].TAXRATE, //13
        TAXTYPE: rowdeposit[i].TAXTYPE, //14
        USERCODE: rowdeposit[i].USERCODE,
      };
      //14
      s1.push(datadeposit[i]);
    }
    //บันทึกตัดยอดเงินมัดจำ
    parameter.append("CSARDEPOSITUSE", JSON.stringify(s1));
    //เพิ่มใหม่ ใช้งานตอนบันทึกตัดยอดเงินมัดจำ
    parameter.append("CSARDEPOSITUSESUM", SUMPAYAMOUNT ? SUMPAYAMOUNT : "");
    parameter.append("BATHDEPOPAY1", BATHDEPOPAY1 ? BATHDEPOPAY1 : "");
    parameter.append("BATHDEPOPAY2", BATHDEPOPAY1 ? BATHDEPOPAY1 : "");
    //เพิ่มใหม่ user field
    parameter.append(
      "Check_Status",
      checkData("number", this.state.Check_Status)
    ); //ค่าตรวจ ตรอ.
    parameter.append("Deposit_No", checkData("text", this.state.Deposit_No)); //เลขที่รับมัดจำ

    parameter.append("CSRECCHQ", JSON.stringify(arrayBill));
    parameter.append("CHEQUEAMOUNT", !Billsum ? 0 : Billsum);

    parameter.append("CSRECCREDIT", JSON.stringify(arrayCredit));
    parameter.append("CREDITAMOUNT", !Creditsum ? 0 : Creditsum);

    parameter.append("CSRECINCOME", JSON.stringify(arrayotherincome));
    parameter.append("INCOMEAMOUNT", !Incomesum ? 0 : Incomesum);

    parameter.append("CSRECEXPENSE", JSON.stringify(arrayexpenses));
    parameter.append("EXPENDAMOUNT", !Expensessum ? 0 : Expensessum);

    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("ARCODE", this.CustomerCode.current.value.trim());
    parameter.append("ARNAME", this.CustomerName.current.value);
    parameter.append("CREDITCODE", this.CreditCode_code.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("BILLADDR", this.state.address);
    parameter.append("TAXNO", this.TaxNumber.current.value);
    parameter.append("TAXTYPE", this.state.PriceType_code);
    parameter.append("SHIPCODE", "Null");
    parameter.append("DEPARTMENT", this.Department_code.current.value);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append("SUMAMOUNT1", this.SumPrice.current.value);
    parameter.append("SUMAMOUNT2", this.ValueExcept.current.value);
    parameter.append("DISCWORD", this.Discountinput.current.value);
    parameter.append("DISCAMOUNT", this.Discount.current.value);
    parameter.append("AFTERDISC", this.ProductValue.current.value);
    parameter.append("TAXRATE", this.TaxPersen.current.value);
    parameter.append("TAXAMOUNT", this.TaxPrice.current.value);
    parameter.append("TOTALAMOUNT", this.valueTax.current.value);
    parameter.append("DEBTAMOUNT", this.TotalPrice.current.value);
    parameter.append("DEBTBALANCE", DEBTBALANCE);
    parameter.append("CALCWTAX", this.state.SaleType);
    parameter.append("CASHAMOUNT", CashReceipt);
    parameter.append("DEPOSITPAYMENT", this.depositpayment.current.value);
    parameter.append("BOOKNO", BOOKNO);
    parameter.append("BANKAMOUNT", BANKAMOUNT);
    parameter.append("BANKEXPEND", BANKEXPEND);
    parameter.append("Remakcase", Remakcase === undefined ? "" : Remakcase);
    parameter.append("Modelcode", checkData("text", this.state.model));
    parameter.append("Colorcode", checkData("text", this.state.colorcar));
    parameter.append("Brandcode", checkData("text", this.state.brandname));
    parameter.append("DUEDATE", this.state.DueDate);
    parameter.append("REMARK", this.REMARK.current.value);
    parameter.append("ArCode2", this.ArCode2.current.value);
    parameter.append("inter", this.interest.current.value);
    parameter.append("registration", this.downpayment.current.value);
    parameter.append("MTCoupon", this.coupon.current.value);
    parameter.append("NOPDI", this.pdinumber.current.value);
    parameter.append("period", this.period.current.value);
    parameter.append(
      "COMMISSION",
      checkData("money", this.commissionfee.current.value)
    );
    parameter.append("Activities", this.state.EventType);
    parameter.append("PSsale", this.state.Typeofcar);
    parameter.append("MachineNo", this.machineNumber.current.value);
    parameter.append(
      "Insurance_car",
      checkData("money", this.state.carinsurance)
    );
    parameter.append("provenance", this.state.provenance);
    parameter.append("SerialNo", this.MTSerialNo.current.value);
    parameter.append(
      "Rnregist",
      checkData("number", this.Rnregist.current.value)
    );
    parameter.append("MTKilometer", this.mileageNumber.current.value);
    parameter.append("_refdoctype", this.state._srefdoctype);
    parameter.append("BrandMC", "NULL");
    parameter.append("CheckKilometer", this.state.CheckKilometer);
    parameter.append("PROJECT", this.state.PROJECT);
    parameter.append(
      "FreeGift",
      typeof this.FreeGift.current.value === undefined
        ? ""
        : this.FreeGift.current.value
    );
    parameter.append("TexDate", this.state.TexDate);
    parameter.append("Contract_fee", this.contractfee.current.value);
    parameter.append(
      "BOOKDESC",
      typeof BOOKDESC !== "undefined" ? BOOKDESC : ""
    );
    parameter.append("COMPNAME", "");
    var Uststus = true;
    console.log("parameter.entries");
    console.log(parameter.entries());

    if (
      Number(this.TaxPersen.current.value) > 0 &&
      this.TaxNumber.current.value === ""
    ) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาใส่เลขใบกำกับภาษี" });
      return;
    }

    for (var pair of parameter.entries()) {
      if (typeof pair[1] === "undefined") {
        pair[1] = "";
      }
      console.log(pair[0], "===", pair[1]);
      if (pair[0] === "ARCODE" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
        //  this.customercodetr.focus();
        return;
      } else if (
        this.state.creditType !== "C00" &&
        pair[0] === "ARCODE2" &&
        pair[1] === ""
      ) {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้าจริง" });
        this.customercodetr.focus();
        return;
      } else if (pair[0] === "DOCGROUP" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" });
        return;
      } else if (pair[0] === "DEPARTMENT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกแผนก" });
        return;
      } else if (pair[0] === "PRODUCT" && pair[1] === "") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกข้อมูลสินค้า" });
        return;
      } else if (pair[0] === "PRODUCT" && pair[1] === "undefined") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert: "กรุณาตัวสอบข้อมูลอาจมีข้อมูลไม่ถูกต้อง",
        });
        return;
      }
    }
    //--------------------------เช็ค เครดิต กับ กลุ่มข้อมูล
    let creditchk = await String(
      this.CreditCode.current.value.match(/เงินสด/gi)
    );
    let groupdatachk = await String(
      this.Groupdata.current.value.match(/เงินสด/gi)
    );

    console.log("sssss", creditchk);
    console.log("sssss", groupdatachk);
    // return
    if (this.CreditCode.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "CreditCode ต้องไม่เท่ากับค่าว่าง" });
      return;
    }
    if (this.Groupdata.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กลุ่มข้อมูล ต้องไม่เท่ากับค่าว่าง" });
      return;
    }

    if (this.Groupdata.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กลุ่มข้อมูล ต้องไม่เท่ากับค่าว่าง" });
      return;
    }

    // ---------------------  เคลม  ----------------------------------
    if (
      this.state.creditType !== "" ||
      this.Groupdata_code.current.value !== ""
    ) {
      let docgroupsubstr = Number(
        this.Groupdata_code.current.value.substr(6, 8)
      );
      console.log(
        "creditType",
        this.state.creditType,
        "Groupdata_code",
        this.Groupdata_code.current.value,
        "docgroupsubstr",
        docgroupsubstr,
        "   "
      );
      if (docgroupsubstr >= 30 && docgroupsubstr <= 34) {
        if (this.state.creditType !== "C00") {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({
            messagealert: "กลุ่มเคลมต้องมีกลุ่มเครดิตเป็นเงินสดเท่านั้น",
          });
          return;
        }
        if (this.state.PriceType_code.toString() !== "2") {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({
            messagealert: "ประเภทราคาต้องเป็นภาษีอัตราศูนย์เท่านั้น",
          });
          return;
        }
        // return
      }
    }
    //- ------------------------------ เงินสด ----------------------------------------------
    if (groupdatachk === "เงินสด") {
      // console.log("sssss", groupdatachk);
      console.log("sssss", creditchk);
      if (creditchk === "null") {
        let docgroupsubstr = this.Groupdata_code.current.value.substr(6, 8);
        // console.log("sssss",Number(docgroupsubstr));
        if (Number(docgroupsubstr) < 30) {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({
            messagealert:
              "กลุ่มข้อมูลกับเครดิตไม่สัมพันธ์กัน กรุณาตรวจสอบอีกครั้ง",
          });
          return;
        }
        if (Number(docgroupsubstr) === 20) {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({
            messagealert:
              "กลุ่มข้อมูลกับเครดิตไม่สัมพันธ์กัน กรุณาตรวจสอบอีกครั้ง",
          });
          return;
        }
      }
    }
    //---------------- เช็คกลุ่มข้อมูล vs กลุ่มลูกค้า----------------------------------------------------
    let docgroupsubstr = this.Groupdata_code.current.value.substr(6, 8);
    console.log(
      "sssss_armaingroup",
      this.state._armaingroup,
      "arsubgroup1",
      this.state._arsubgroup1,
      "docgroupsubstr",
      docgroupsubstr
    );
    if (docgroupsubstr === "05") {
      // if (this.state._arsubgroup1 !== "AR101") {
      //   Uststus = false;
      //   this.setState({ opensnackbar: true })
      //   this.setState({ color: "warning" })
      //   this.setState({ icon: ErrorIcon })
      //   this.setState({ messagealert: "กลุ่มลูกค้าไม่สัมพันธ์กับกลุ่มข้อมูล กรุณาตรวจสอบอีกครั้ง" })
      //   return
      // }
      if (this.state.creditType === "C00") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert: "กลุ่มขายส่งต้องมีกลุ่มเครดิตเป็นไม่เท่ากับ เงินสด ",
        });
        return;
      }
    }
    // return
    if (Uststus === true) {
      this.setState({ openBackdrop: true });

      await axios
        .post(genpostURL("CSSALES/Save?user=&provenance=web"), parameter)
        .then((res) => {
          //await axios.post(genpostURLTEST("/Save?"), parameter).then(res => {
          // console.log("gen", genpostURL("/Save?"), "resdata CSSALE", res);
          if (res.data.status === "success") {
            this.setState({ opensnackbar: true });
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            this.setState({ openBackdrop: false });
            setTimeout(() => {
              if (this.state.reporturl !== "") {
                this._print(res.data.docno);
              } else {
                this.ReplacePage(window.location.pathname + location.search);
              }
            }, 30);
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                "บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง Errcode: " +
                res.data.status +
                "message" +
                res.data.message,
            });
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ openBackdrop: false });
        })
        .finally((_) => {
          // this.setState({ openBackdrop: false })
        });
    }
  };
  /*----------------------------------------------------------------------------------------------------------------------------*/
  SelectSetData = async (data1, data2) => {
    console.log(data1, ":::::PriceType::::::", data2);
    switch (data1) {
      case "Calendar":
        this.setState({ SaleDate: data2 });
        break;
      case "Calendar1":
        this.setState({ TexDate: data2 });
        break;
      case "Calendar2":
        this.setState({ DueDate: data2 });
        break;
      case "PROJECT":
        this.setState({ PROJECT: data2 });
        break;
      case "PriceType":
        console.log("GETPRICE  PriceType", data2);
        this.setState({ PriceType_code: data2 });
        if (this.CustomerCode.current.value !== "") {
          this.confirm();
        }
        this.ReLoadData();
        switch (data2) {
          case "0":
            // this.TaxNumber.current.value = this.DeliNumber.current.value
            break;
          case "1":
            // this.TaxNumber.current.value = this.DeliNumber.current.value
            break;
          case "2":
            // this.TaxNumber.current.value = ""
            break;
          default:
            break;
        }
        break;
      case "SaleType":
        this.setState({ SaleType: data2 });
        break;
      case "checkkm":
        this.setState({ CheckKilometer: data2 });
        break;
      default:
        break;
    }
  };
  confirm = () => {
    console.log("sssss confirm", this.state.SelSaleRefopen);
    if (this.state.SelSaleRefopen === false) {
      var col = this.state.products;
      for (var i = 0; i < col.length; i++) {
        if (col[i].productcode !== undefined) {
          this.setState({ show1: true });
        }
      }
    }
  };
  _pricetype = (Texttype) => {
    console.log("_pricetype", Texttype);
    this.setState({ defaultselect: [Texttype] });
    this.setState({ PriceType_code: Texttype });
    this.ReLoadData();
  };
  //data.Customercode, data.Customername, data.Creditcode, data.Texttype, data.Address, data._accountcdoe, data._Prefis, data._Arname, data._Surname, data._argroup
  Get_PopUparcode = (
    CustomerCode,
    CustomerName,
    Creditcode,
    Texttype,
    _address,
    accountcode,
    _prefis,
    _Arname,
    _Surname,
    _armaingroup,
    _arsubgroup1
  ) => {
    this.CloseDialog(false);
    console.log(_armaingroup, "==", _arsubgroup1);
    // console.log("_arsubgroup1", _arsubgroup1)
    this.setState({ _armaingroup: _armaingroup });
    this.setState({ _arsubgroup1: _arsubgroup1 });
    this.setState({ customer1: CustomerCode });
    this.CustomerCode.current.value = CustomerCode;
    this.CustomerName.current.value = CustomerName;
    this.setState({ address: _address });
    this._pricetype(Texttype);
    this.setState({ _accountcode: accountcode });
    setTimeout(() => {
      this.CreditCode_code.current.value = Creditcode;
      this.CreditCode.current.value = CreditCode(Creditcode);
      this.setState({ creditType: Creditcode });
      //TAXTYPE
    }, 30);
    var dateP = parseFloat(Creditcode.substring(1));
    var SaleDate1 = new Date();
    this.setState({ DueDate: this.CalendarOnChange(SaleDate1, dateP) });
    this.confirm();
  };
  Get_PopUpOther = async (val) => {
    this.CloseDialog(false);
    var data = val.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        // Checkdocgroup(data[0], "CSSALE").then((result) => {
        //     here you can use the result of promiseB
        //   this.Groupdata_code.current.value = data[0]
        //   this.Groupdata.current.value = result
        // });
        this.onAddValue("Groupdata", data[0], false);
        break;
      case "CreditCode":
        console.log("CreditCode", data[0], "::::::", data[1]);
        this.CreditCode_code.current.value = data[0];
        this.CreditCode.current.value = data[1];
        setTimeout(() => {
          this.setState({ creditType: data[0] });
          localStorage.setItem("creditType", data[0]);
        }, 100);
        setTimeout(() => {
          console.log("Get_PopUpOther" + this.state.creditType);
        }, 300);
        var dateP = parseFloat(data[0].substring(1));
        var SaleDate1 = new Date();
        this.setState({ DueDate: this.CalendarOnChange(SaleDate1, dateP) });
        break;
      case "Department":
        this.Department_code.current.value = data[0];
        this.Department.current.value = data[1];
        this.setState({ Department_txt: data[1] });
        break;
      case "Branch":
        this.Branch_code.current.value = data[0];
        this.Branch.current.value = data[1];
        this.setState({ Branch_txt: data[1] });
        break;
      case "EventType":
        this.EventType.current.value = data[1];
        this.setState({ EventType: data[0] });
        break;
      case "typeofcar":
        this.typeofcar.current.value = data[1];
        this.setState({ Typeofcar: data[0] });
        break;
      default:
        break;
    }
  };
  CalendarOnChange = (data, DateUp) => {
    var Backup = "";
    var today = new Date(data);
    if (DateUp) {
      today.setDate(today.getDate() + DateUp);
    }
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    today = dd + "/" + mm + "/" + (yyyy + 543);
    setTimeout(() => {
      Backup = this.state.MenuItem;
      this.setState({ MenuItem: "" });
    }, 0);
    setTimeout(() => {
      this.setState({ MenuItem: Backup });
    }, 10);
    return today;
  };
  _productcodeButton(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].btn1;
    var btnShow = "this.state.products";
    switch (btn) {
      case 1:
        btnShow = (
          <>
            <SearchRoundedIcon
              style={{ cursor: "pointer", fontSize: "24px" }}
              onClick={this.Switch_PopUpItem}
              onMouseDown={(e) => {
                this.setState({ TBLastClick: row.C0 });
              }}
            />
          </>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload = (cell, row, enumObject, rowIndex) => {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  };
  _cellButton_btn_C3 = (cell, row, enumObject, rowIndex) => {
    // console.log("_cellButton_btn_C4 active" + this.state.products[rowIndex].btn_C4);
    var btn = this.state.products[rowIndex].btn_C3;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButton_btn_C4 = (cell, row, enumObject, rowIndex) => {
    // console.log("_cellButton_btn_C4 active" + this.state.products[rowIndex].btn_C4);
    var btn = this.state.products[rowIndex].btn_C4;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpwarehouse.bind(null, "setwarehousetable")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  };
  _cellButtonC5(cell, row, enumObject, rowIndex) {
    var btn = this.state.products[rowIndex].C5_btn;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <div
            id={"Icon_row" + row.C0}
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.Switch_PopUpItem}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.C0 });
            }}
          >
            <i
              className="fas fa-sort-down icon_down"
              style={{ paddingTop: "7px" }}
            ></i>
          </div>
        );
        break;
      case 2:
        btnShow = (
          <div id={"Icon_row" + row.C0} style={{ cursor: "pointer" }}>
            <i className="far fa-trash-alt" style={{ fontSize: "14px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = (
          <i
            id={"Icon_row" + row.C0}
            style={{ fontSize: "10px", color: "#000" }}
          ></i>
        );
        break;
    }
    return <div>{btnShow}</div>;
  }
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ products: data });
  };
  rowClassNameFormat = (row, rowIdx) => {
    return "trClassName";
  };
  onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.productcode });
    this.setState({ id: id });
    var Pr = this.state.products;
    var j = rowTable;
    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });
    this.setState({ reduce: false });
    // จำนวนเต็มเวลาคลิก
    let quantity = row.quantity,
      saleprice = row.saleprice;
    if (col === 9 && quantity !== "" && quantity !== undefined) {
      row.quantity = parseFloat(quantity).toFixed(0);
    } else if (col === 10 && saleprice !== "" && saleprice !== undefined) {
      row.saleprice = parseFloat(saleprice).toFixed(0);
    }
    var CH = false;
    switch (col) {
      case 5:
      case 6:
        CH = true;
        break;
    }
    if (CH === true) {
      this.setState({ WHRow: id });
    } //set rowclick
    for (var i = 0; i < Pr.length; i++) {
      Pr[i].btn1 = 0;
      Pr[i].btn_C3 = 0;
      Pr[i].btn_C4 = 0;
    }
    // หาจากล่างขึ้นบน
    for (var i = this.state.products.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products Table
      if (!this.state.products[i].productcode) {
        j = i;
      }
    }

    // BTN ค้นหาได้เฉพาะในแถว
    if (
      (col === 1 && j === id) ||
      (col === 1 &&
        Pr[id].productcode !== undefined &&
        Pr[id].productcode !== "")
    ) {
      this.setState({ col1: true });
      this.setState({ C1_editable: true });
      Pr[id].btn1 = 1;
    } else if (
      col === 4 &&
      typeof row.productcode !== "undefined" &&
      row.productcode !== ""
    ) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_C3 = 1;
    } else if (
      col === 6 &&
      typeof row.productcode !== "undefined" &&
      row.productcode !== ""
    ) {
      this.setState({ productcodeinrow: row.productcode });
      this.setState({ productcodeinrow1: row.warehouse });
      Pr[id].btn_C4 = 1;
    } else {
      this.setState({ C1_editable: false });
    }

    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.productcode !== "undefined" && row.productcode !== "") {
      this.setState({ col: true });
      // BTN วันที่
    }
    if (this.state.Bonus === "0" && this.state.Claim === "0") {
      this.setState({ reduce: true });
    }

    this.setState({ products: Pr });
  };

  onAfterSaveCell = async (row, cellName, cellValue) => {
    let datatable = this.state.products;
    this.setState({ row: row.C0 - 1 });
    var cellValue1 = this.state.cellValue;
    // ทศนิยม 2 ตำแหน่ง ปริมาณ
    console.log("row.productgroup", row.productgroup);
    let quantity = row.quantity,
      saleprice = row.saleprice;
    if (cellName === "quantity" && quantity !== "") {
      // if (row.productset !== "1" && row.parentcode === "") {
      if (
        row.productcode !== "" &&
        row.productset !== "1" &&
        row.productgroup !== "03"
      ) {
        // เช็คสต๊อกสินค้า
        await Checkstock(
          row.productcode,
          "",
          row.unitcode,
          row.warehouse,
          row.location,
          row.productgroup,
          row.refdocno !== "" ? "saleorder" : ""
        ).then((resstock) => {
          console.log("resstock", resstock);
          if (Number(row.quantity) > Number(resstock)) {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                row.productcode +
                " จำกัดสินค้าไม่พอใช้งาน ในคลังมีจำนวน " +
                resstock +
                " " +
                row.unitname,
            });
            if (resstock > 0) {
              row.quantity = parseFloat(resstock).toFixed(2);
            } else {
              row.quantity = "";
            }
          }
        });
      }
      this.ReLoadData2(row.productcode);
      // }
      //-------------------------------------------------------สิ้นสุดการเช็คปริมาณ ------------------------------------------------------------------
    } else if (cellName === "warehouse") {
      // if (row.productset !== "1" && row.parentcode === "") {
      if (
        row.productcode !== "" &&
        row.productset !== "1" &&
        row.productgroup !== "03"
      ) {
        // เช็คสต๊อกสินค้า
        await Checkstock(
          row.productcode,
          "",
          row.unitcode,
          row.warehouse,
          row.location,
          row.productgroup,
          row.refdocno !== "" ? "saleorder" : ""
        ).then((resstock) => {
          console.log("resstock", resstock);
          if (Number(row.quantity) > Number(resstock)) {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                row.productcode +
                " จำกัดสินค้าไม่พอใช้งาน ในคลังมีจำนวน " +
                resstock +
                " " +
                row.unitname,
            });
            if (resstock > 0) {
              row.quantity = parseFloat(resstock).toFixed(2);
            } else {
              row.quantity = "";
            }
          }
        });
      }
      if (row.productset !== "2") {
        this.ReLoadData2(row.productcode);
      }
      // }
      //-------------------------------------------------------สิ้นสุดการเช็คปริมาณ ------------------------------------------------------------------
    } else if (cellName === "location") {
      // if (row.productset !== "1" && row.parentcode === "") {
      if (
        row.productcode !== "" &&
        row.productset !== "1" &&
        row.productgroup !== "03"
      ) {
        // เช็คสต๊อกสินค้า
        await Checkstock(
          row.productcode,
          "",
          row.unitcode,
          row.warehouse,
          row.location,
          row.productgroup,
          row.refdocno !== "" ? "saleorder" : ""
        ).then((resstock) => {
          console.log("resstock", resstock);
          if (Number(row.quantity) > Number(resstock)) {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                row.productcode +
                " จำกัดสินค้าไม่พอใช้งาน ในคลังมีจำนวน " +
                resstock +
                " " +
                row.unitname,
            });
            if (resstock > 0) {
              row.quantity = parseFloat(resstock).toFixed(2);
            } else {
              row.quantity = "";
            }
          }
        });
      }
      if (row.productset !== "2") {
        this.ReLoadData2(row.productcode);
      }
      // }
      //-------------------------------------------------------สิ้นสุดการเช็คปริมาณ ------------------------------------------------------------------
    } else if (cellName === "saleprice" && saleprice !== "") {
      row.saleprice = parseFloat(saleprice).toFixed(2);
      this.ReLoadData();
    }
    if (
      cellName === "productcode" &&
      cellValue !== "" &&
      cellValue1 !== cellValue
    ) {
      var col = this.state.products;
      col[row.C0 - 1] = [];
      col[row.C0 - 1].C0 = row.C0;
      col[row.C0 - 1].productcode = "";
      col[row.C0 - 1].btn1 = row.btn1;
      this.setState({ products: col });
      // await Checkstock(row.productcode, "", row.unitcode, row.warehouse, row.location, row.productgroup, row.refdocno !== "" ? "saleorder" : "").then(resstock => {

      //   if (Number(row.quantity) < Number(resstock)) {
      this.AddDataTable(cellValue, row.C0 - 1, "", "");

      // if (row.productcode !== "" && row.productset !== "1" && row.productgroup !== "03") { // เช็คสต๊อกสินค้า
      //   await Checkstock(row.productcode, "", row.unitcode, row.warehouse, row.location, row.productgroup, row.refdocno !== "" ? "saleorder" : "").then(resstock => {
      //     console.log("resstock", resstock);
      //     if (Number(row.quantity) > Number(resstock)) {
      //       this.setState({ opensnackbar: true })
      //       this.setState({ color: "warning" })
      //       this.setState({ icon: ErrorIcon })
      //       this.setState({ messagealert: row.productcode + " จำกัดสินค้าไม่พอใช้งาน ในคลังมีจำนวน " + resstock + " " + row.unitname })
      //       if (resstock > 0) {
      //         row.quantity = parseFloat(resstock).toFixed(2)
      //       } else {
      //         row.quantity = ""
      //       }
      //     }
      //   })
      // }

      //   }
      // })
    } else if (cellName === "productcode" && cellValue === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    } else if (
      cellName === "location" ||
      (cellName === "warehouse" && cellValue !== "")
    ) {
      let w = Checkwarehousepermission(
        cellName,
        cellValue,
        this.state.userCode,
        row.productcode
      );
      w.then((v) => {
        datatable[row.C0 - 1].warehouse = v[0];
        datatable[row.C0 - 1].location = v[1];
        this.setState({
          products: datatable,
        });
      });
    } else if (
      (cellName === "quantity" && cellValue !== "") ||
      (cellName === "discountword" && cellValue !== "") ||
      (cellName === "saleprice" && cellValue !== "")
    ) {
      await this.ReLoadData();
    } else {
    }
  };
  async AddDataTable2() {
    var col = this.state.products;
    let saleprice = "";
    for (let i = 0; i < col.length; i++) {
      if (col[i].productcode !== undefined && col[i].productcode !== "") {
        //-----------------------------------------------------
        await cheackprice(
          col[i].productcode,
          1,
          this.CustomerCode.current.value,
          col[i].unitcode,
          this.state.PriceType_code,
          this.state.DueDate,
          this.CreditCode_code.current.value
        )
          .then((res) => {
            if (res !== undefined) {
              saleprice = parseFloat(res).toFixed(2);
            }
          })
          .catch((err) => {
            console.log("cheackprice err ", err);
            console.log(err);
          });
        col[i].saleprice = parseFloat(Number(saleprice)).toFixed(2);
        this.ReLoadData();
      }
    }
  }
  Get_PopUpItem = (code, data, stocktype) => {
    this.AddDataTable(code, this.state.TBLastClick - 1, data, stocktype);
  };
  Get_PopUpSERIALNUMBER = (data1, data2) => {
    var dataArray = this.state.products;
    dataArray[this.state.se_Row - 1].SERIALNUMBER = data2.SERIALNUMBER;
    // dataArray[this.state.se_Row - 1].warehouse = data2.WAREHOUSE;
    dataArray[this.state.se_Row - 1].location = data2.LOCATION;
    this.setState({ products: dataArray });
  };
  AddDataTable = (ItemCode, row, data, stocktype) => {
    var col = this.state.products;
    for (var i = 0; i < col.length && col[i].productcode; i++) {
      // เปิดใช้งานใหม่ 3-5-65
      if (col[i].productcode === ItemCode) {
        //col[i].quantity = parseFloat(Number(col[i].quantity) + 1).toFixed(2);
        // this.setState({ products: col });
        // this.ReLoadData();
        return;
      }
    }
    var url =
      "CSPRODUCT/GetAllProductcode?code=" +
      ItemCode +
      "&user=" +
      localStorage.getItem("Username");
    console.log("GetAllProductcode", genURL(url));
    axios.get(genURL(url)).then(async (ref) => {
      console.log("ref", ref.data);
      var j = 0;
      if (row > -1) {
        j = row;
      } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
        j = this.state.TBLastClick - 1;
      } else {
        for (var i = this.state.products.length - 1; i >= 0; i--) {
          // หาจากล่างขึ้นบน
          if (!this.state.products[i].productcode) {
            j = i;
          }
        }
      }
      if (ref.data.length > 0) {
        let saleprice = 0;
        let Discountword = 0;
        let stock = 0;
        let discountamount = 0;
        let productset = "";
        let parentcode = "";
        let amount = "";
        let warehouse = "";
        let location = "";
        let MAINGROUP = "";
        for (let index = 0; index < ref.data.length; index++) {
          MAINGROUP = await Checkmaingroup(ref.data[index].PRODUCTCODE);
          // console.log("PARENTCODE", ref.data[index].PARENTCODE, "ref.data[index].PRODUCTSET", ref.data[index].PRODUCTSET)
          try {
            parentcode =
              typeof ref.data[index].PARENTCODE !== "undefined"
                ? ref.data[index].PARENTCODE
                : "";
          } catch (error) {}
          console.log("parentcode", parentcode);

          warehouse = await this.state.defaultwarehouse;
          location = await this.state.defaultlocetion;

          if (parentcode === "") {
            // if (MAINGROUP !== "03") {
            await cheackprice(
              ref.data[index].PRODUCTCODE,
              1,
              this.CustomerCode.current.value,
              ref.data[index].UNITCODE,
              ref.data[index].ITEMTAXTYPE,
              this.state.DueDate,
              this.CreditCode_code.current.value
            )
              .then((res) => {
                if (res !== undefined) {
                  saleprice = parseFloat(res).toFixed(2);
                }
              })
              .catch((err) => {
                console.log("cheackprice err ", err);
                console.log(err);
              });
          } else if (ref.data[index].PRODUCTSET === 1) {
            // PRODUCTSET
            saleprice =
              ref.data[index].UNITPRICE === 0.0
                ? ""
                : ref.data[index].UNITPRICE;
            stock = ref.data[index].Quantity;
            discountamount = saleprice;
            amount = saleprice;
            Discountword = saleprice;
          } else {
            // รายการย่อยสินค้าชุด
            try {
              saleprice = ref.data[index].UNITPRICE;
              Discountword = ref.data[index].DISCWORD;
              stock = ref.data[index].QUANTITY;
              discountamount = parseFloat(ref.data[index].DISCAMOUNT).toFixed(
                2
              );
              amount = ref.data[index].AMOUNT;
            } catch (error) {
              console.log(`err${error}`);
            }
          }
          productset =
            parentcode !== "" && String(ref.data[index].PRODUCTSET) === "0"
              ? "2"
              : String(ref.data[index].PRODUCTSET);
          try {
            if (ref.data[index].MAINGROUP === "01") {
              this.checkuserField(ref.data[index].PRODUCTCODE);
            }
          } catch (error) {}
          let unit = "";
          await checkunit(ref.data[index].UNITCODE).then((data) => {
            unit = data;
          });
          //  console.log("PRODUCTSET->", ref.data[index].PRODUCTSET, "saleprice->", saleprice, "amount->", amount);
          // console.log("test cheackprice", unit);
          col[j] = {
            C0: j + 1,
            productcode: ref.data[index].PRODUCTCODE,
            btn1: col[0].btn1,
            productname: ref.data[index].PRODUCTNAME,
            warehouse: warehouse,
            location: location,
            unitname: unit,
            unitcode: ref.data[index].UNITCODE,
            quantity: stock,
            saleprice: saleprice,
            discountword: Discountword,
            discountamount: discountamount,
            amount: amount,
            refdocno: "",
            stocktype: ref.data[index].STOCKTYPE,
            productgroup: MAINGROUP,
            itemtaxtype: ref.data[index].ITEMTAXTYPE,
            productset: productset,
          };
          j++;
          await this.setState({ products: col });
          await this.setState({ openFullScreenDialog: false });
          await this.ReLoadData();
        }
      } else {
        // this.ReLoadData();
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "ไม่พบข้อมูลสินค้าในคลังสาขาของคุณ" });
      }
    });
    setTimeout(() => {
      document.getElementById("TableLoadItem").innerHTML = "";
    }, 3000);
  };
  // search ราคาขาย
  ReLoadData2 = async (productcode) => {
    console.log(
      "ReLoadData2",
      productcode,
      this.state.products[this.state.row].productgroup,
      this.state.products[this.state.row].itemtaxtype
    );

    // if (this.state.products[this.state.row].productgroup !== "03") {
    await cheackprice(
      productcode,
      this.state.products[this.state.row].quantity,
      this.CustomerCode.current.value,
      this.state.products[this.state.row].unitcode,
      this.state.PriceType_code,
      this.state.DueDate,
      this.CreditCode_code.current.value
    )
      .then((res) => {
        if (res !== undefined) {
          // saleprice = parseFloat(res).toFixed(2)
          this.state.products[this.state.row].saleprice = parseFloat(
            Number(res)
          ).toFixed(2);
        }
      })
      .catch((err) => {
        console.log("cheackprice err ", err);
        console.log(err);
      });
    this.ReLoadData();
  };
  //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
  ReLoadData = async (directions) => {
    try {
      let col = this.state.products;
      let NewCol = [];
      let j = 0;
      let Ch = 0;
      for (let i = 0; i < col.length; i++) {
        if (col[i].productcode) {
          if (col[i].productcode[0] + "" + col[i].productcode[1] === "11") {
            Ch++;
          }
          NewCol[j] = col[i];
          NewCol[j].C0 = j + 1;

          /*------------------------------------------------------------*/
          if (col[i].discountword === "-") {
            NewCol[j].discountword = col[i].saleprice * col[i].quantity;
          } else if (col[i].discountword === "") {
            NewCol[j].discountword = NewCol[j].quantity === "" ? "" : "0.00";
          } else if (
            col[i].discountword * 1 >
            col[i].saleprice * col[i].quantity * 1
          ) {
            NewCol[j].discountword = col[i].saleprice * col[i].quantity;
          }
          // ส่วนของแถมหรือเคลม
          if (
            col[i].productcode !== "" &&
            typeof col[i].productcode !== "undefined"
          ) {
            if (
              col[i].productgroup.toString() === "02" &&
              this.state.selectName === "giveaway"
            ) {
              // ของแถม
              if (this.state.selectgiveaway === true) {
                NewCol[j].discountword = parseFloat(
                  Number(col[i].saleprice) * Number(col[i].quantity)
                ).toFixed(2);
              } else {
                NewCol[j].discountword = "0.00";
              }
            }
            // console.log("this.state.selectNamessssss", this.state.selectName, "col[i].stocktype", col[i].stocktype, " NewCol[j]", j, "this.state.selectName", this.state.selectName, "this.state.selectclaim", this.state.selectclaim);
            if (
              (col[i].productgroup.toString() === "02" ||
                col[i].productgroup.toString() === "03") &&
              this.state.selectName === "claim"
            ) {
              if (this.state.selectclaim === true) {
                NewCol[j].discountword = parseFloat(
                  Number(col[i].saleprice) * Number(col[i].quantity)
                ).toFixed(2);
              } else {
                NewCol[j].discountword = "0.00";
              }
            }
          }
          let str = "" + NewCol[j].discountword;
          let res = str.match("%");
          if (NewCol[j].quantity) {
            if (res) {
              let newstr = str.split("%");
              NewCol[j].amount = parseFloat(
                col[i].saleprice * col[i].quantity -
                  col[i].saleprice * col[i].quantity * (newstr[0] / 100)
              ).toFixed(2);
              NewCol[j].discountamount = parseFloat(
                col[i].saleprice * col[i].quantity * (newstr[0] / 100)
              ).toFixed(2);
            } else {
              if (
                col[i].discountword * 1 >
                col[i].saleprice * col[i].quantity * 1
              ) {
                NewCol[j].discountword = col[i].saleprice * col[i].quantity * 1;
              }
              // if (col[i].parentcode === "" && col[i].productset !== "1") {
              let sum =
                col[i].saleprice * col[i].quantity * 1 -
                NewCol[j].discountword * 1;
              NewCol[j].amount = sum.toFixed(2);
              NewCol[j].discountamount = parseFloat(
                NewCol[j].discountword
              ).toFixed(2);
              // }
            }
          }
          j++;
        }
      }
      if (Ch > 0) {
        this.setState({ Show_SERIALNUMBER: true });
      } else {
        this.setState({ Show_SERIALNUMBER: false });
      }
      for (let i = j; i < col.length; i++) {
        NewCol[j] = { C0: j + 1 };
        j++;
      }
      await this.setState({ products: NewCol });
      await this.Cal_Price();
      /* this.Discountinput.current.value = ""; */
      // this.Discount.current.value = parseFloat(0).toFixed(2);
    } catch (error) {}
  };
  /* อันใหม่ */
  Cal_Price = (e) => {
    console.log("PriceType_code", this.state.PriceType_code);
    let SumPriceProduct = 0.0;
    let SumPriceProduct1 = 0.0;
    let TaxPersen = Number(this.TaxPersen.current.value);
    let TaxPersen1 = 100 + TaxPersen;
    let Discountinput = Number(this.Discountinput.current.value);
    for (let i = 0; i < this.state.products.length; i++) {
      if (this.state.products[i].amount) {
        SumPriceProduct1 += parseFloat(this.state.products[i].amount);

        if (this.state.products[i].PRODUCTSET !== "2") {
          this.Discount.current.value = parseFloat(Discountinput).toFixed(2);
          // เดิม parseFloat((SumPriceProduct1 * Discountinput) / 100).toFixed(2)
        }
        SumPriceProduct = SumPriceProduct1;
      }
    }
    this.setState({ allpriceforTax_: SumPriceProduct });
    this.Discountinput.current.value = parseFloat(Discountinput).toFixed(2);
    this.TaxPersen.current.value = parseFloat(TaxPersen).toFixed(2);
    this.SumPrice.current.value = parseFloat(SumPriceProduct).toFixed(2);
    SumPriceProduct -= Number(this.Discount.current.value);

    //--------------------------------------เช็คประเภทภาษี------------------------------------------

    if (Number(this.state.PriceType_code) === 0) {
      // ราคาไม่รวมภาษี
      SumPriceProduct -= Number(this.state.sumsapdeposit);
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);

      // ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(
        (SumPriceProduct * 7) / 100
      ).toFixed(2);

      this.TotalPrice.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
      this.valueTax.current.value = parseFloat(
        (SumPriceProduct * 7) / 100 + SumPriceProduct
      ).toFixed(2);
    } else if (Number(this.state.PriceType_code) === 1) {
      // ราคารวมภาษี
      //รวมจำนวนเงิน
      // this.SumPrice.current.value = SumPriceProduct.toFixed(2);
      //รวมจำนวนเงิน - หักเงินมัดจำ
      console.log(SumPriceProduct);
      console.log(this.state.sumsapdeposit);
      SumPriceProduct -= Number(this.state.sumsapdeposit);
      console.log("SumPriceProduct", SumPriceProduct);
      //มูลค่าสินค้า
      this.ProductValue.current.value = parseFloat(
        SumPriceProduct - (SumPriceProduct * TaxPersen) / TaxPersen1
      ).toFixed(2);
      //ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = parseFloat(
        (SumPriceProduct * TaxPersen) / TaxPersen1
      ).toFixed(2);
      //มูลค่ารวมภาษี
      this.valueTax.current.value = parseFloat(SumPriceProduct).toFixed(2);
      //รวมเงินทั้งสิ้น
      this.TotalPrice.current.value = parseFloat(SumPriceProduct).toFixed(2);
    } else {
      //ภาษีอัตราศูนย์
      SumPriceProduct -= Number(this.state.sumsapdeposit);
      //ภาษีมูลค่าเพิ่ม
      this.TaxPrice.current.value = "0.00";
      this.ProductValue.current.value = parseFloat(SumPriceProduct).toFixed(2);
      //this.SumPrice.current.value = SumPriceProduct.toFixed(2);
      this.TotalPrice.current.value = SumPriceProduct.toFixed(2);
      this.valueTax.current.value = SumPriceProduct.toFixed(2);
    }
    let ValueExcept = 0;
    if (this.ValueExcept.current.value) {
      ValueExcept = parseFloat(this.ValueExcept.current.value).toFixed(2);
    } else {
      this.ValueExcept.current.value = "0.00";
    }
    this.setState({ AmountPayable: this.TotalPrice.current.value });
  };
  Cal_Price1 = (e) => {
    if (e.key === "Enter" && e.target.value !== "") {
      this.Cal_Price();
    }
  };
  onChangeData = (e) => {
    let Ref = this.state.LastRef;
    if (e.key === "Enter" && e.target.value !== "") {
      this.onAddValue(Ref, e.target.value).then((res) => {
        this.SwitchValue(Ref, "EnterEvent");
      });
    }
  };
  _chkGroup(val, row) {
    // เช็คกลุ่มสินค้า
    // console.log(this.state.codeGroup.substring(7, 8));
    try {
      let lastCode = this.state.codeGroup.substring(7, 8);
      this.setState({ lastCode_s_: lastCode });
    } catch (error) {
      this.setState({ lastCode_s_: 99 });
    }
    // console.log(lastCode);
    if (lastCode === 8) {
      let url =
        "CSPRODUCT/CHKGroup?code=" +
        val +
        "&user=" +
        localStorage.getItem("Username");
      // console.log(url);
      let loadname = "load" + row - 1;
      // let j = rowData;
      let col = this.state.products;
      axios.get(genURL(url), { timeout: 60000 }).then((res) => {
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            // console.log(res.data[i].MAINGROUP);
            this.setState({ groupNumber: res.data[i].MAINGROUP });
          }
        }
      });
    } else {
      this.setState({ groupNumber: 99 });
    }
  }
  _chkdiscount = (row, cellValue) => {
    let col = this.state.products;
    this._chkGroup(col[row.C0 - 1].productcode, col[row.C0 - 1].C0);
    setTimeout(() => {
      this.setState({ products: col });
    }, 100);
    this.ReLoadData();
    // }, 300);
  };

  reCheckData = async (type, val, fix) => {
    switch (type) {
      case "Groupdata":
        CheckCodeDocGroup(val, "CSSALE")
          .then((result) => {
            console.log("result Groupdata", result);
            this.Groupdata_code.current.value = val;
            this.Groupdata.current.value = result;
            this.setState({ Groupdata_txt: result });
          })
          .finally((_) => {
            CheckTaxrate(val, "CSSALE").then(async (result) => {
              this.TaxPersen.current.value = await result;
              // if (fix === false) {
              //   this.GenerateDocno(value, "CSSALE")
              // }
            });
          });
        break;
    }
  };
  onAddValue = async (type, value, Fix) => {
    if (value) {
      switch (type) {
        case "Groupdata":
          // let text
          Checkdocgroup(value, "CSSALE", Fix)
            .then((result) => {
              // here you can use the result of promiseB
              console.log("ssssss", result);
              this.Groupdata_code.current.value = value;
              this.Groupdata.current.value = result;
              this.setState({ Groupdata_txt: result });
              //text = result
            })
            .finally((_) => {
              CheckTaxrate(value, "CSSALE").then(async (result) => {
                console.log("sssss", result);
                this.TaxPersen.current.value = await result;
                if (Fix === false) {
                  this.GenerateDocno(value, "CSSALE");
                }
              });
            });
          break;
        case "CustomerCode":
          await CheckAr(value)
            .then((result) => {
              console.log("CheckAr", result);
              if (result !== "") {
                let data = result.split("|");
                this.CustomerCode.current.value = value;
                this.CustomerName.current.value = data[0];
                this.CreditCode_code.current.value = data[1];
                this.CreditCode.current.value = CreditCode(data[1]);
                this.setState({ _arsubgroup1: data[4] });
                this.setState({ creditType: data[1] });
                this.setState({ address: data[6] });
                this._pricetype(data[5]);
                let dataP = parseFloat(data[1].substring(1));
                this.setState({
                  DueDate: this.CalendarOnChange(new Date(), dataP),
                });
                this.confirm();
              } else {
                // AlertPopup("Warning", "ไม่พบข้อมูล!");
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({
                  messagealert: "ไม่พบข้อมูลลูกค้ากรุณาลองใหม่อีกครั้ง",
                });
                this.CustomerCode.current.value = "";
                this.CustomerName.current.value = "";
                this.CreditCode_code.current.value = "";
                this.CreditCode.current.value = "";
                this.setState({ DueDate: this.CalendarOnChange(new Date()) });
                this.setState({ _arsubgroup1: "" });
                this.setState({ creditType: "" });
              }
            })
            .catch((err) => {
              this.setState({ _arsubgroup1: "" });
              this.setState({ creditType: "" });
              this.CustomerCode.current.value = "";
              this.CustomerName.current.value = "";
              this.CreditCode_code.current.value = "";
              this.CreditCode.current.value = "";
              this.setState({ DueDate: this.CalendarOnChange(new Date()) });
              console.log(err);
            });
          break;
        case "Csuser":
          await CheckUser(value)
            .then((result) => {
              if (result !== undefined) {
                this.Csuser_code.current.value = value;
                this.Csuser.current.value = result;
              } else {
                // AlertPopup("Warning", "ไม่พบข้อมูล!");
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({
                  messagealert: "ไม่พบข้อมูลพนักงานกรุณาลองใหม่อีกครั้ง",
                });
                this.Csuser_code.current.value = "";
                this.Csuser.current.value = "";
              }
            })
            .catch((err) => {
              this.Csuser_code.current.value = "";
              this.Csuser.current.value = "";
              console.log(err);
            });
          break;
        case "Department":
          CheckDepartmentname(value).then((result) => {
            //console.log("result",result);
            this.Department_code.current.value = value;
            this.Department.current.value = result;
            this.setState({ Department_txt: result });
            this.setState({ Department_code: value });
            this.setState({ Department: result });
          });
          break;
        case "Branch":
          await CheckBrabchname(value)
            .then((result) => {
              if (result !== undefined) {
                this.Branch_code.current.value = value;
                this.Branch.current.value = result;
                this.setState({ Branch_txt: result });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({
                  messagealert: "ไม่พบข้อมูลสาขากรุณาลองใหม่อีกครั้ง",
                });
                // AlertPopup("Warning", "ไม่พบข้อมูล!");
                this.Branch_code.current.value = "";
                this.Branch.current.value = "";
                this.setState({ Branch_txt: "" });
              }
            })
            .catch((err) => {
              this.Branch_code.current.value = "";
              this.Branch.current.value = "";
              this.setState({ Branch_txt: "" });
              console.log(err);
            });
          break;
        case "checkkm":
          await Checknamecupon(value)
            .then((result) => {
              if (result !== undefined && result !== "") {
                this.setState({ CheckKilometer: value });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({
                  messagealert: "ไม่พบข้อมูลคูปองกรุณาลองใหม่อีกครั้ง",
                });

                // AlertPopup("Warning", "ไม่พบข้อมูล!");
                this.setState({ CheckKilometer: "" });
              }
            })
            .catch((err) => {
              this.setState({ CheckKilometer: "" });
            });
          break;
      }
    }
  };
  GenerateDocno(value, table) {
    Gendocno(value, table).then((result) => {
      // console.log(result);
      this.DeliNumber.current.value = result;
      // if (this.state.PriceType_code !== "2") {
      if (Number(this.TaxPersen.current.value) > 0) {
        this.TaxNumber.current.value = result;
      } else {
        this.TaxNumber.current.value = "";
      }
    });
  }
  _reCHK = async (RowData) => {
    this.setState({ openBackdrop: true });
    this.CloseDialog(false);
    this.setRow(rowTable);
    this.setState({ _saveStatus: true });
    /* Pageserachmain */
    // this.DeliNumber.current.value = RowData.productname
    let url = genURL("CSSALE/Getbycode?DOCNO=" + RowData[0].docno);
    // console.log("res _reCHK", url);
    // console.log("res _reCHK", RowData);
    axios.get(url, { timeout: 60000 }).then(async (res) => {
      console.log("res _reCHK", res.data);
      /* Addvalue */
      if (res.data.length === 1) {
        await this.onAddValue("Branch", res.data[0].SITECODE);
        this.setState({ SiteCode_code: res.data[0].SITECODE });
      }
      this.depositpayment.current.value = res.data[0].DEPOSITPAYMENT;
      this.setState({ ressale: res.data });
      console.log("TAXTYPE", res.data[0].TAXTYPE);
      await this._pricetype(res.data[0].TAXTYPE);
      this.CustomerCode.current.value = res.data[0].ARCODE;
      this.CustomerName.current.value = res.data[0].ARNAME;
      // console.log("res.data[0].DOCGROUP", res.data[0].DOCGROUP)
      // await this.onAddValue("Groupdata", res.data[0].DOCGROUP, true)
      await this.reCheckData("Groupdata", res.data[0].DOCGROUP, true);
      // this.onAddValue("Groupdata", res.data[0].DOCGROUP)
      this.DeliNumber.current.value = res.data[0].DOCNO;
      this.TaxNumber.current.value = res.data[0].TAXNO;
      this.CreditCode_code.current.value = res.data[0].CREDITCODE;
      this.CreditCode.current.value = CreditCode(res.data[0].CREDITCODE);
      this.setState({ SaleDate: res.data[0].DOCDATE });
      this.setState({
        TexDate: Moment(res.data[0].TAXDATE, "YYYY-MM-DD")
          .add(543, "year")
          .format("DD/MM/YYYY"),
      });
      this.setState({ DueDate: ReDate(res.data[0].DUEDATE) });
      this.REMARK.current.value = RowData.remark;
      await this.onAddValue("Csuser", res.data[0].SALECODE);
      await this.onAddValue("Department", res.data[0].DEPARTMENT);
      this.setState({ Department: res.data[0].DEPARTMENT });
      this.setState({
        defaultvaluewarehouse:
          "รหัสคลัง: " +
          res.data[0].SITECODE +
          "  รหัสที่เก็บ: " +
          res.data[0].SITECODE +
          "001",
      });
      /*-----------------------------------------------------------------*/
      this.ArCode2.current.value = res.data[0].ArCode2;
      this.interest.current.value = res.data[0].inter;
      this.downpayment.current.value = res.data[0].registration;
      this.period.current.value = res.data[0].period;
      this.commissionfee.current.value = res.data[0].COMMISSION;
      this.contractfee.current.value = res.data[0].Contract_fee;
      this.coupon.current.value = res.data[0].MTCoupon;
      this.FreeGift.current.value = res.data[0].FreeGift;
      this.pdinumber.current.value = res.data[0].NOPDI;
      this.mileageNumber.current.value = res.data[0].MTKilometer;
      this.machineNumber.current.value = res.data[0].MachineNo;
      this.MTSerialNo.current.value = res.data[0].SerialNo;
      this.setState({ CheckKilometer: res.data[0].CheckKilometer });
      this.setState({ AmountPayable: res.data[0].SUMAMOUNT1 });

      this.WTAXAMOUNT.current.value = res.data[0].WTAXAMOUNT;
      this.setState({ receivedwithholdingdevalue: res.data[0].WTAXAMOUNT });
      this.ValueExcept.current.value = res.data[0].SUMAMOUNT2;
      /* this.ValueExcept.current.value = res.data[0].EXCHANGERATE */
      this.SumPrice.current.value = res.data[0].SUMAMOUNT1;
      this.Discountinput.current.value = res.data[0].DISCWORD;
      this.Discount.current.value = res.data[0].DISCAMOUNT;
      this.ProductValue.current.value = res.data[0].AFTERDISC;
      this.TaxPersen.current.value = res.data[0].TAXRATE;
      this.TaxPrice.current.value = res.data[0].TAXAMOUNT;
      this.valueTax.current.value = res.data[0].TOTALAMOUNT;
      this.TotalPrice.current.value = res.data[0].BATHDEBTAMOUNT;
      this.setState({ PROJECT: res.data[0].PROJECT });
    });
    let url1 = "CSSALESUB/Getbycode?DOCNO=" + RowData[0].docno;
    axios.get(genURL(url1), { timeout: 60000 }).then(async (res) => {
      console.log("CSSALESUB", res.data);
      if (res.data.length > 0) {
        let data = this.state.products;
        for (let i = 0; i < res.data.length; i++) {
          let unit = "";
          await checkunit(res.data[i].UNITCODE).then((data) => {
            unit = data;
          });
          data[i].productcode = res.data[i].PRODUCTCODE;
          data[i].productname = res.data[i].PRODUCTNAME;
          data[i].warehouse = res.data[i].SITECODE;
          /* data[i].location = res.data[i].SITECODE + "1"; */
          data[i].location = res.data[i].LOCATION;
          data[i].unitcode = res.data[i].UNITCODE;
          data[i].unitname = unit;
          /*   ? res.data[i].STOCKUNIT: res.data[i].UNITCODE; */
          data[i].quantity = res.data[i].QUANTITY;
          data[i].saleprice = res.data[i].AMOUNT;
          data[i].discountword = res.data[i].DISCAMOUNT;
          data[i].amount = res.data[i].NETAMOUNT;
          data[i].refdocno = res.data[i].DIMENSION1;
          data[i].stocktype = res.data[i].STOCKTYPE;
          data[i].unitcode = res.data[i].UNITCODE;
          data[i].refdocno = res.data[i].REFDOCNO;
          data[i].itemtaxtype = res.data[i].ITEMTAXTYPE;
        }
        await this.setState({ products: data });
        await this.Cal_Price();
        await this.setState({ openBackdrop: false });
        await console.log("CSSALESUB products", this.state.products);
      }
    });
  };
  /*----------------------------------------------------------Switch------------------------------------------------------------------*/
  Switch_PopUpItem = () => {
    this.setState({
      typeFullScreenDialog: "SelectItem",
      titleFullScreenDialog: "เลือกรายการสินค้า",
      openFullScreenDialog: true,
    });
  };
  Switch_PopupArcode = (e) => {
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาลูกค้า-AR" });
  };
  Switch_OtherPopup = (e) => {
    //ชื่อ
    this.setState({ OtPopupType: e });
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //openFullScreenDialog
    this.setState({ openFullScreenDialog: true });
    if (e === "Groupdata") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" });
    }
    if (e === "Department") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" });
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" });
    }
    if (e === "CreditCode") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-creditcode" });
    }
  };
  _print = (val) => {
    this.setState({
      openReportFullScreenDialog: true,
      titleReportFullScreenDialog: "พิมพ์ใบขายสินค้าและบริการ",
    });

    try {
      if (formPrintdata.length > 1) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert:
            "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length,
        });
        return;
      }
    } catch (error) {
      console.log("error", error);
    }
    if (this.DeliNumber.current.value !== "") {
      this._callForm(
        localStorage.getItem("creditType"),
        this.DeliNumber.current.value
      );
    } else if (val !== "") {
      this._callForm(localStorage.getItem("creditType"), val);
    } else {
      // AlertPopup("Warning", "ไม่อยู่ในเงื่อนไขการพิมพ์");
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "ไม่อยู่ในเงื่อนไขการพิมพ์" });
      return;
    }
    setTimeout(() => {
      localStorage.removeItem("countprint");
      localStorage.removeItem("creditType");
      localStorage.removeItem("docno");
    }, 200);

    // this.setState({ SwitchReport: !this.state.SwitchReport });
  };
  _callForm = (vel, val1) => {
    console.log("C00vel", vel);

    // https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FSALESlip&standAlone=true&j_username=rpt&j_password=042615116&output=pdf&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&provenance=web&startdate=2022-05-24&stopdate=2022-05-24&type=&warehouse=&brand=&model=&color=&code=&docno=100602-650524-001&status=&sitecode=1006&location=&docno=100602-650524-001
    switch (vel) {
      case "C00": //***เงินสด
        this.setState({
          openReportFullScreenDialog: true,
          titleReportFullScreenDialog: "พิมพ์ใบบันทึกขายสินค้าและบริการ",
          urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${val1}`,
        });
        break;
      default:
        //เงินผ่อน
        this.setState({
          openReportFullScreenDialog: true,
          titleReportFullScreenDialog: "พิมพ์ใบบันทึกขายสินค้าและบริการ",
          urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${val1}`,
        });
        break;
    }
  };
  //------------------------------------------------------------------------
  Switch_SelSaleRef3 = (e) => {
    this.setState({ SelSaleRefopen: true });
    if (this.CustomerCode.current.value) {
      // this.setState({ PopUpTYpeSelSaleRef3: e });
      // this.setState({ SwitchSelSaleRef3: !this.state.SwitchSelSaleRef3 });
      //ชื่อ
      this.setState({ typeFullScreenDialog: e });
      //open
      this.setState({ openFullScreenDialog: true });
      //title
      this.setState({
        titleFullScreenDialog: "ค้นหาเอกสารอ้างอิงขาย-SelSelRef3",
      });
    } else {
      // AlertPopup("Warning", "");
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาใส่! รหัสลูกค้า" });
    }
  };
  Switch_Csardeposit = (e) => {
    if (e === "Csardeposit") {
      if (!this.CustomerCode.current.value) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้าด้วยครับ" });
        return;
      }
      // if (this.SumPrice.current.value === "0.00") {
      //   this.setState({ opensnackbar: true })
      //   this.setState({ color: "warning" })
      //   this.setState({ icon: ErrorIcon })
      //   this.setState({ messagealert: "กรุณากรอกปริมาณ หรือราคาขายด้วยครับ" })
      //   return
      // }
      console.log(this.state.tbCsardeposit);
      let arrforparm = {
        ARCode: this.CustomerCode.current.value,
        tbCsardeposit: this.state.tbCsardeposit,
        taxtype: this.state.PriceType_code,
      };
      this.setState({ openFullScreenDialog: true });
      this.setState({ typeFullScreenDialog: e });
      this.setState({ titleFullScreenDialog: "บันทึกตัดยอดเงินมัดจำ" });
      this.setState({ dataforpopup: arrforparm });
    }
  };
  // Switch_PopUpwarehouse by dk
  Switch_PopUpwarehouse = (type) => {
    console.log("case setwarehousetable");
    switch (type) {
      case "setwarehousetable":
        if (this.state.productcodeinrow !== "") {
          //ชื่อ
          this.setState({ typeFullScreenDialog: type });
          //open
          this.setState({ openFullScreenDialog: true });
          //title
          this.setState({ titleFullScreenDialog: "เลือกคลังและตำแหน่งเก็บ" });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบรหัสสินค้าในแถวที่ท่านเลือก" });
          return;
        }
        break;
    }
  };

  // จัดการข้อมูลหลังจากดึงกลับมาจากป๊อบอัพ
  Get_SelSaleRef3 = async (
    data,
    data1,
    creditCode,
    department,
    sitecode,
    salecode,
    reftaxtype
  ) => {
    this.CloseDialog(false);
    this.setState({ openBackdrop: true });
    console.log("sssssGet_SelSaleRef3", data);
    console.log("sssssGet_SelSaleRef3 creditCode", creditCode);
    console.log(
      "sssssGet_SelSaleRef3 PriceType_code",
      this.state.PriceType_code
    );
    console.log("sssssGet_SelSaleRef3 reftaxtype", reftaxtype);

    this.setState({
      _srefdoctype: 2,
      creditType: creditCode,
    });
    let split_data = data.split("|");
    let col = this.state.products;
    let j = this.state.products.length;
    let productset = "";
    // let maingroup
    // for (let c = 0; c < col.length; c++) {
    // if (col[c].productcode !== split_data[1] && col[c].productcode === undefined) {
    // console.log("col[c].productcode",c,"::::", col[c].productcode);
    let chk = true;
    let stock = "";
    console.log("ssssss", split_data[17]);
    if (
      split_data[17] === 0
      // && typeof col[c].productcode !== "undefined"
    ) {
      // สินค้าปกติ

      await Checkstock(
        split_data[1],
        this.state.provenance,
        split_data[14],
        split_data[12],
        split_data[13],
        // split_data[16],
        String(split_data[19]),
        "saleorder"
      ).then((resstock) => {
        console.log("ChkStock", resstock, "split_data 12", split_data[1]);
        if (Number(split_data[4]) > Number(resstock)) {
          stock = parseFloat(resstock).toFixed(2);
        } else if (resstock > 0) {
          stock = split_data[4];
        } else {
          stock = 0.0;
        }
      });
    } else if (split_data[17] === 2) {
      // สินค้าย่อยในสินค้าชุด
      stock = split_data[4];
    } else {
      stock = split_data[4];
    }
    // if (chk === true) {
    col[j] = {
      productcode: split_data[1],
      productname: split_data[2],
      warehouse: split_data[12],
      location: split_data[13],
      unitname: split_data[3],
      unitcode: split_data[14],
      quantity: parseFloat(stock).toFixed(2),
      //split_data[4],
      saleprice: split_data[7],
      discountword: split_data[8],
      amount: split_data[7],
      refdocno: split_data[0],
      refLineID: split_data[15] ? split_data[15] : "0",
      productgroup: split_data[16],
      stocktype: split_data[17],
      itemtaxtype: split_data[18] ? split_data[18] : "0",
      productset: split_data[19],
    };
    // }
    // }
    await this.setState({ products: col });
    // setTimeout(() => {
    console.log("creditCode", creditCode);
    this.CreditCode_code.current.value = creditCode;
    this.CreditCode.current.value = await CreditCode(creditCode);
    // console.log(salecode, "สาขา");
    /* this.onAddValue("Csuser", salecode); */
    await this.onAddValue("Department", department);
    await this.onAddValue("Branch", sitecode);
    // this.onAddValue("CustomerCode", this.CustomerCode.current.value)
    await this.setState({
      SiteCode_code: sitecode,
    });

    await this._pricetype(reftaxtype);
    // }, 300);

    // setTimeout(() => {
    //  this.ReLoadData();
    let dateP = await parseFloat(
      this.CreditCode_code.current.value.substring(1)
    );
    let SaleDate1 = new Date();
    await this.setState({ DueDate: this.CalendarOnChange(SaleDate1, dateP) });
    /* this.Get_PopUpOther(); */
    //  }, 350);
    // this.onAddValue(split_data[1]);
    await this.setState({ SwitchSelSaleRef3: false });
    await this.setState({ openBackdrop: false });

    await this.ReLoadData();
  };
  Get_SelARDepositUse = (data) => {
    this.CloseDialog(false);
    let split_data = data.split("|");
    // this.Deposit_No.current.value = split_data[0];
    this.depositpayment.current.value = split_data[1];
    this.setState({ SwitchSelARDepositUse: !this.state.SwitchSelARDepositUse });
    this.setState({ deprositState: split_data[1] }); // เอาไว้ใช้คำนวนเบี้ยใหม่
    setTimeout(() => {
      this.setState({
        allpriceforTax_: this.state.allpriceforTax_ - this.state.deprositState,
      });
      this._updateCalculatdi();
    }, 100);
  };
  ///-------------------------------------save data ----------------------------------------------
  _connectsaveData = () => {
    if (this.CustomerCode.current === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า ...!" });
      return;
    } else if (this.CustomerName.current === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกชื่อลูกค้า ...!" });
      return;
    } else if (!this.state.products[0].productcode) {
      console.log("sssss", this.state.products[0].productcode);
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณาเพิ่มข้อมูลสินค้า ...!" });
      return;
    } else {
      // เช็คข้อมูลในตาราง
      for (
        let i = 0;
        i < this.state.products.length && this.state.products[i].productcode;
        i++
      ) {
        if (this.state.products[i].productcode) {
          let C4Send =
            typeof this.state.products[i].location !== undefined
              ? this.state.products[i].location
              : "";
          let C3Send =
            typeof this.state.products[i].warehouse !== undefined
              ? this.state.products[i].warehouse
              : "";
          /* console.log("this.state.products[i].stocktype");
          console.log(C4Send + ":::::" + C3Send); */
          if (this.state.products[i].stocktype === 0) {
            if (C3Send === "") {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: "กรุณาเลือกคลัง" });
              return;
            }
            if (C4Send === "") {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: "กรุณาเลือกตำแหน่งเก็บ" });
              return;
            }
          }
          if (Number(this.state.products[i].saleprice) <= 0) {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                "กรุณาตรวจสอบราคาสินค้า รหัส " +
                this.state.products[i].productcode +
                " (แถวที่ " +
                (i + 1) +
                ") อีกครั้ง",
            });
            return;
          }
          if (Number(this.state.products[i].quantity) <= 0) {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                "กรุณาตรวจสอบปริมาณสินค้า รหัส " +
                this.state.products[i].productcode +
                " (แถวที่ " +
                (i + 1) +
                ") อีกครั้ง",
            });
            return;
          }
        }
      }
    }
    switch (this.state.creditType) {
      case "C00":
        if (Number(this.TotalPrice.current.value) > 0) {
          this.setState({ typeFullScreenDialog: "SaveMoney" });
          this.setState({ titleFullScreenDialog: "บันทึกรับเงิน" });
          this.setState({ openFullScreenDialog: true });
        } else if (Number(this.TotalPrice.current.value) >= 0) {
          this.saveData(0, "", 0, 0);
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณาตรวจยอดเงิน" });
        }
        break;
      default:
        if (Number(this.TotalPrice.current.value) >= 0) {
          this.saveData(0, "", 0, 0);
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณาตรวจยอดเงิน" });
        }
        break;
    }
  };
  //************************---------------------get_PopUpSaveMoney ------ */
  _get_PopUpSaveMoney = (
    status,
    data1,
    data2,
    data3,
    Bill,
    Billsum,
    Credit,
    Creditsum,
    Income,
    Incomesum,
    Expenses,
    Expensessum,
    CHARGEAMOUNT,
    CHARGEPAY1,
    CHARGEPAY2,
    tbBill,
    tbCredit,
    tbotherincome,
    tbexpenses,
    //เพิ่มเติม
    arrayBill,
    arrayCredit,
    arrayexpenses,
    arrayotherincome
  ) => {
    this.setState({ openFullScreenDialog: false });
    let split_data2 = data3.split("|");
    let CashReceipt = data2; //เงินสด
    let BOOKNO = split_data2[0]; //เลขบัญชี
    let BANKAMOUNT = split_data2[1]; //ยอดเงินโอน
    let BANKEXPEND = split_data2[2]; //ค่าธรรมเนียมจ่ายหักบัญชี
    let BOOKDESC =
      split_data2[3] === ""
        ? ""
        : typeof split_data2[3] !== undefined
        ? split_data2[3]
        : "";
    let Remakcase = split_data2[3] === "" ? "" : split_data2[3];
    this.saveData(
      CashReceipt,
      BOOKNO,
      BANKAMOUNT,
      BANKEXPEND,
      BOOKDESC,
      Remakcase,
      Bill,
      Billsum,
      Credit,
      Creditsum,
      Income,
      Incomesum,
      Expenses,
      Expensessum,
      // เพิ่มเติม
      arrayBill,
      arrayCredit,
      arrayexpenses,
      arrayotherincome
    );
  };

  ReturnData = async (e) => {
    this.CloseDialog(e[0]);
    console.log(e);
    // if (e[1] === "Csardeposit") {
    this.setState({ openFullScreenDialog: e[0] });
    if (e !== "") {
      if (e[1]) {
        this.setState({ tbCsardeposit: e[1] });
        console.log(e[1]);
        let sum = 0;
        for (let i = 0; i < e[1].length; i++) {
          sum += Number(e[1][i].PAYAMOUNT);
        }
        console.log(sum);
        await this.setState({ sumsapdeposit: sum });
        this.depositpayment.current.value = parseFloat(sum).toFixed(2);
        this.Cal_Price();
      }
    }
    // }
  };
  _calculatdiscountkey = (e) => {
    if (e.key === "Enter") {
      this._calculatdiscount();
    }
  };
  Get_warehouse = async (data) => {
    this.CloseDialog(false);
    let DataValue = data.split("|");
    let Pr = this.state.products;
    let r = this.state.id;
    Pr[r].warehouse = DataValue[0];
    Pr[r].location = DataValue[2];
    Pr[r].quantity = (1).toFixed(2);
    setTimeout(() => {
      this.setState({ products: Pr });
      //   console.log(this.state.WHRow);
      // this.checkStkwarehouse(this.state.id);
    }, 100);
    this.ReLoadData();
  };
  checkStkwarehouse = (row) => {
    console.log(row);
    let col = this.state.products;
    let urll =
      "CSSTKWAREHOUSE/checkstockqty?productcode=" +
      col[row].productcode +
      "&warehouse=" /* this.state.siteCodeUser */ +
      this.state.productcodeinrow1 +
      "&location=" +
      col[row].location;
    let chki = 0;
    axios
      .get(genURL(urll), { timeout: 60000 })
      .then((res) => {
        console.log(res);
        let chkloc = 0;
        for (let i = 0; i < res.data.length; i++) {
          chkloc = chkloc + 1;
          chki = chki + 1;
          // col[row].location = res.data[i].LOCATION;
          // col[row].quantity = (1).toFixed(2);
        }
        setTimeout(() => {
          this.setState({ products: col });
        }, 100);
      })
      .then((_) => {
        setTimeout(() => {
          this.ReLoadData();
        }, 500);
      });
  };
  switchshowform = (e) => {
    this.setState({ showform: !this.state.showform });
  };
  //**  ค้นหายี่ห้อ รุ่น* */*********************************************************** */
  _handleSearch = (query) => {
    this.setState({ isLoading: true });
    let _url = "";
    let _code = "";
    let _name = "";
    switch (this.state.chkfocus) {
      case "dimension":
        _url = "CSDIMENSION1/getdata?";
        _code = "CODE";
        _name = "MYNAMETH";
        break;

      case "brandname":
        _url = "CSPDSUBGROUP2/getAll?top=2000";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
      case "model":
        _url = "CSPDSUBGROUP4/getAll?top=2000";
        _code = "CODE";
        _name = "MYNAMETH";
        break;

      case "color":
        _url = "/CSPDSUBGROUP5/getAll?top=2000";
        _code = "CODE";
        _name = "MYNAMETH";
        break;
    }
    return axios.get(genURL(_url), { timeout: 60000 }).then((res) => {
      console.log("resdata", res);
      if (res !== "error") {
        let element = [];
        for (let index = 0; index < res.data.length; index++) {
          element.push(res.data[index][_code] + " | " + res.data[index][_name]);
        }
        console.log(element);
        this.setState({
          isLoading: false,
          options: element,
        });
      }
      setTimeout(() => {
        console.log(this.state.options);
      }, 300);
      return "SS";
    });
  };
  _blurinput = () => {
    //  console.log("xxxx" + this.input.current.value);
    let _txtselect = "";
    let _code = "";
    switch (this.state.chkfocus) {
      case "dimension":
        _txtselect = "" + this.state.selecteddimension;
        _code = _txtselect.split("|");
        this.setState({ dimension: _code[0].trim() });
        // setTimeout(() => {
        //      console.log("_nametxt" + this.state.dimension);
        // }, 100);
        break;
      case "brandname":
        _txtselect = "" + this.state.selectedbrandname;
        _code = _txtselect.split("|");
        this.setState({ brandname: _code[0].trim() });
        // setTimeout(() => {
        //      console.log("_nametxt" + this.state.brandname);
        // }, 100);
        break;
      case "model":
        _txtselect = "" + this.state.selectedmodel;
        _code = _txtselect.split("|");
        this.setState({ model: _code[0].trim() });
        // setTimeout(() => {
        //      console.log("_nametxt" + this.state.dimension);
        // }, 100);
        break;
      case "color":
        _txtselect = "" + this.state.selectedcolor;
        _code = _txtselect.split("|");
        this.setState({ colorcar: _code[0].trim() });
        break;
    }
    // setTimeout(() => {
    //     console.log("dimension" + this.state.dimension);
    // }, 100);
  };
  //*** */**************************************************************************** */
  onCheckChange = async (e) => {
    await this.setState({ selectName: e.target.name });
    if (e.target.name === "giveaway") {
      await this.setState({ selectgiveaway: e.target.checked });
    }
    if (e.target.name === "claim") {
      await this.setState({ selectclaim: e.target.checked });
    }
    await this.ReLoadData();
  };
  //--------------------------------Gen เลขที่ใบส่งของ------------------------------------
  loaddocMax() {
    if (this.Groupdata_code.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "!!! กรุณาเลือกกลุ่มข้อมูลก่อน" });
      return;
    }
    this.GenerateDocno(this.Groupdata_code.current.value, "CSSALE");
  }

  checkuserField = (productcode) => {
    // -------------- เช็ค user field-------------------------
    let url = "CSPRODUCT/ProductFullbycode?code=" + productcode;
    console.log(genURL(url));
    axios.get(genURL(url), { timeout: 60000 }).then((res) => {
      for (let index = 0; index < res.data.length; index++) {
        this.machineNumber.current.value = res.data[index].MachineNo;
        this.MTSerialNo.current.value = res.data[index].SerialNo;
      }
    });
  };
  onClickTopbar = async (e) => {
    console.log(e);
    switch (e) {
      case "save":
        // this.setState({ PopUpSaveMoney: true});
        this._connectsaveData();
        break;
      case "new":
        this.ReplacePage(window.location.pathname + location.search);
        break;
      case "print":
        this._print(null);
        break;
      case "search":
        //ชื่อ
        this.setState({ typeFullScreenDialog: e });
        //open
        this.setState({ openFullScreenDialog: true });
        //title
        this.setState({ titleFullScreenDialog: "บันทึกขายสินค้าและบริการ" });
        break;
      case "SelSaleRef3":
        this.Switch_SelSaleRef3("SelSaleRef3");
        break;
      case "Csardeposit":
        this.Switch_Csardeposit("Csardeposit");
        break;
      case "SaveMoney":
        this.setState({ typeFullScreenDialog: "SaveMoney" });
        this.setState({ titleFullScreenDialog: "บันทึกรับเงิน" });
        this.setState({ openFullScreenDialog: true });
        break;
      case "Salewithholding":
        //ชื่อ
        this.setState({ typeFullScreenDialog: e });
        //open
        this.setState({ openFullScreenDialog: true });
        //title
        this.setState({ titleFullScreenDialog: "ภาษีถูกหัก ณ ที่จ่าย" });
        break;
      default:
        break;
    }
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
  };

  resvalue = (data) => {
    console.log(data);
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({ defaultwarehouse: data.warehouse });
      this.setState({ defaultlocetion: data.location });
    }
  };

  ReplacePage = (e) => {
    this.setState({ openBackdrop: false });
    window.location.replace(e);
  };
  CloseReportDialog = (e) => {
    this.setState({ openReportFullScreenDialog: e });
    this.ReplacePage(window.location.pathname + location.search);
  };

  receivedwithholdingdeData = (e) => {
    //ยอดรวมภาษี
    this.setState({ receivedwithholdingdevalue: e });
    this.WTAXAMOUNT.current.value = e;
  };

  render() {
    const Item = styled(Paper)(({ theme }) => ({
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    }));
    const type = this.state.typeFullScreenDialog;
    const editprice =
      localStorage.getItem("Editamountpermision") !== "0" ? false : true;

    // const { idPokemon } = this.props.params
    // let { id } = useParams();

    this.withholding = (e) => {
      console.log("withholding", e);
      this.setState({
        withholdingData: e,
        openFullScreenDialog: false,
      });
    };

    return (
      <div
        className="PSApp"
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        onChange={this.onChange}
        onBlur={this.onBlur}
      >
        <FullScreenDialognew
          open={this.state.openReportFullScreenDialog}
          title={this.state.titleReportFullScreenDialog}
          CloseDialog={(e) => this.CloseReportDialog(e)}
        >
          <Repostview url={this.state.urlsend} />
        </FullScreenDialognew>
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {type === "SaveMoney" ? (
            <PopUpSaveMoney
              closePopup={(e) => this.CloseDialog(e)}
              AmountPayable={this.state.AmountPayable}
              date={this.state.SaleDate}
              from="CSSALE"
              get_PopUpSaveMoney={this._get_PopUpSaveMoney}
              Customer={this.CustomerCode.current.value}
              pms="S|1|1|1|1|1|1"
              //if  ยอดรวมเงิน-ยอดภาษี ณ ที่จ่าย
              withholdingdevalue={this.state.receivedwithholdingdevalue}
              recheckeddata={this.state.ressale}
              depositpayment={this.depositpayment.current.value}
            />
          ) : (
            ""
          )}
          {type === "SelectItem" ? (
            <PopUpItem
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpItem={this.Get_PopUpItem}
            />
          ) : (
            ""
          )}
          {type === "search" ? (
            // <PopUpSearchDoc closePopup={e => this.CloseDialog(e)} Get_Popup={this._reCHK} from="CSSALE" />
            <Rechecked Dataselect={(e) => this._reCHK(e)} from="CSSALE" />
          ) : null}
          {type === "Search_ARCode" ? (
            <PopupArcode
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUparcode={this.Get_PopUparcode}
            />
          ) : null}
          {type === "Groupdata" ||
          type === "Department" ||
          type === "Branch" ||
          type === "CreditCode" ? (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              from="CSSALE"
              userSite={this.state.siteCodeUser}
            />
          ) : null}
          {type === "setwarehousetable" ? (
            <PopUpwarehouse
              closePopup={(e) => this.CloseDialog(e)}
              type="setdefaultwarehouse"
              Get_PopUpOther={this.Get_warehouse}
              productcodeinrow={this.state.productcodeinrow}
              productcodeinrow1={this.state.productcodeinrow1}
              from="CSSALE"
            />
          ) : null}
          {type === "SelARDepositUse" ? (
            <PopUpSelARDepositUse //
              Get_SelARDepositUse={this.Get_SelARDepositUse}
              type={"SelARDepositUse"}
              ARCODE={this.CustomerCode.current.value}
              TAXTYPE={this.state.PriceType_code}
            />
          ) : null}
          {type === "Csardeposit" ? (
            <PopupCsardeposit
              parm={this.state.dataforpopup}
              resdata={(e) => this.ReturnData(e)}
              recheckeddata={this.state.ressale}
              from="CSSALE"
            />
          ) : null}
          {type === "SelSaleRef3" ? ( //เลือกเอกสารสั่งขาย
            <PopUpSelSaleRef3
              Get_SelSaleRef3={this.Get_SelSaleRef3}
              type={"SelSaleRef3"}
              ARCODE={this.CustomerCode.current.value}
            />
          ) : null}
          {type === "Salewithholding" ? (
            <Salewithholding
              userData={[
                this.CustomerCode.current.value.trim(),
                this.CustomerName.current.value.trim(),
              ]}
              resdata={(e) => this.withholding(e)}
              withholdingdefaultValue={this.state.withholdingData}
              receivedwithholdingdeData={(e) =>
                this.receivedwithholdingdeData(e)
              }
              recheckeddata={this.state.ressale}
              from="CSSALE"
            />
          ) : null}
        </FullScreenDialog>
        {this.state.showform ? (
          <PopUpReport close={this.switchshowform} url={this.state.urlsend} />
        ) : null}
        <Topbar
          listmenu={listmenu}
          title="บันทึกขายสินค้าและบริการ"
          onClick={(e) => this.onClickTopbar(e)}
        />
        <div className="PSAppfrom" style={{ margin: "10px" }}>
          {/*  Grid ส่วนบน*/}
          <Grid
            container
            spacing={1}
            sx={{
              width: "100%",
              margin: 0,
              "& .MuiGrid-item": {
                display: "flex",
                flexDirection: "column",
              },
            }}
          >
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <div className="form-group input-Bottom ">
                <div className="input-group ">
                  <span className="input-group-addon">รหัสลูกค้า</span>
                  <input
                    type="text"
                    className="form-control "
                    name="CustomerCode"
                    ref={this.CustomerCode}
                    /* onKeyPress={this.Get_Arcode} */
                  />
                  <span
                    onClick={() => this.Switch_PopupArcode("Search_ARCode")}
                    id="iconCustomerCode"
                    className="input-group-addon icon"
                  >
                    <i>
                      {" "}
                      <ArrowDropDownRoundedIcon fontSize="small" />
                    </i>
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={8} lg={4} xl={4}>
              <div className="form-group input-Bottom ">
                <div className="input-group ">
                  <span
                    id="iconCustomerName"
                    className="input-group-addon icon"
                  >
                    <i className="fas fa-user"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    readOnly
                    ref={this.CustomerName}
                  />
                </div>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <div className="form-group input-Bottom ">
                <div className="input-group ">
                  <span className="input-group-addon">กลุ่มข้อมูล</span>
                  {/* hiddenhidden */}
                  <input
                    type="text"
                    className="form-control hidden"
                    ref={this.Groupdata_code}
                  />
                  <input
                    type="text"
                    className="form-control"
                    name="Groupdata"
                    ref={this.Groupdata}
                  />
                  <span
                    id="iconGroupdata"
                    className="input-group-addon icon"
                    onClick={this.Switch_OtherPopup.bind(null, "Groupdata")}
                  >
                    <i>
                      {" "}
                      <ArrowDropDownRoundedIcon fontSize="small" />
                    </i>
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <MaterialUIPickers
                title="วันที่ขาย"
                DateValue={(e) => this.SelectSetData("Calendar", e)}
                defaultdate={this.state.SaleDate}
                open={this.state.checkenableInput["DOCDATE"]}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">เลขที่ใบส่งของ</span>
                  <input
                    type="text"
                    className="form-control"
                    ref={this.DeliNumber}
                    readOnly
                  />
                  <span id="iconTaxNumber" className="input-group-addon icon">
                    <i
                      className="fas fa-sync-alt"
                      onClick={(e) => this.loaddocMax()}
                    ></i>
                  </span>
                </div>
              </div>
            </Grid>

            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">ใบกำกับภาษี</span>
                  <input
                    type="text"
                    className="form-control"
                    ref={this.TaxNumber}
                    readOnly={this.state.OpenTAXNO}
                  />
                  {/* <span id="iconTaxNumber" className="input-group-addon icon">
                           <i className="fab fa-expeditedssl"></i> 
                        </span> */}
                </div>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <MaterialUIPickers
                title="วันที่ใบกำกับ"
                DateValue={(e) => this.SelectSetData("Calendar1", e)}
                defaultdate={this.state.TexDate}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <span className="input-group-addon">รหัสเครดิต</span>
                  <input
                    type="text"
                    className="form-control hidden"
                    ref={this.CreditCode_code}
                  />
                  <input
                    type="text"
                    className="form-control"
                    ref={this.CreditCode}
                    readOnly
                  />
                  <span
                    id="iconCreditCode"
                    className="input-group-addon icon"
                    onClick={this.Switch_OtherPopup.bind(null, "CreditCode")}
                  >
                    <i>
                      {" "}
                      <ArrowDropDownRoundedIcon fontSize="small" />
                    </i>
                  </span>
                </div>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group">
                  <SelectDatas
                    origin="PriceType" // ประเภท
                    valueSelect={(e) => this.SelectSetData("PriceType", e)} // รับค่ากลับ
                    title="ประเภทราคา"
                    defaultselect={this.state.defaultselect} // ค่าเริ่มต้นของ ประเภทราคา
                  />
                </div>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <MaterialUIPickers
                title="ครบกำหนด"
                DateValue={(e) => this.SelectSetData("Calendar2", e)}
                defaultdate={this.state.DueDate}
                open={this.state.checkenableInput["DOCDATE"]}
              />
            </Grid>
            <Grid item sm={12} xs={12} md={4} lg={4} xl={4}>
              <div className="form-group input-Bottom">
                <div className="input-group" style={{ marginTop: "10px" }}>
                  <input
                    type="checkbox"
                    name="giveaway"
                    onChange={this.onCheckChange}
                  ></input>
                  <span className="choiceSty">
                    &nbsp;ของแถม&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  </span>
                  <input
                    type="checkbox"
                    name="claim"
                    onChange={this.onCheckChange}
                  ></input>
                  <span className="choiceSty">&nbsp;เคลม</span>
                </div>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={12} lg={12} xl={12}>
              <CustomInputtext
                title="คลังเริ่มต้น"
                value={this.state.defaultvaluewarehouse}
                disabledvalue={true}
                of_title={false}
                of_btn={false}
                source={"CSWAREHOUSEALL"}
                propsvalue={this.resvalue}
                fullWidth={true}
              />
            </Grid>
          </Grid>
        </div>
        {/* alert สอบถามการเปลี่ยนแปลงราคา */}
        <div className="container-fluid">
          <div>
            <Modal
              show={this.state.show1}
              size="sm" /*กดข้างนอก Modal onHide={() => { this.setState({ show1: false }) }}  */
            >
              <Modal.Header
                style={{
                  // backgroundColor: 'rgba(190, 200, 215, 0.9)',
                  borderRadius: "10px 10px 0px 0px",
                }}
              >
                <div className="PopUpOtherDivH1">
                  <i className="fas " style={{ color: "black" }}>
                    {" "}
                    ปรับราคา{" "}
                  </i>
                </div>
                <div className="PopUpOtherDivH2">
                  <i
                    className="fas fa-times"
                    style={{ color: "white" }}
                    onClick={() => {
                      this.setState({ show1: false });
                    }}
                  ></i>
                </div>
              </Modal.Header>
              <Modal.Body style={{ fontSize: "20px", left: "12px" }}>
                ต้องการปรับราคาขายต่อหน่วยใหม่หรือไม่!{" "}
              </Modal.Body>
              <Modal.Footer
                style={{
                  // backgroundColor: 'rgba(190, 200, 215, 0.9)',
                  borderRadius: "0px 0px 10px 10px",
                }}
              >
                <Button
                  variant="secondary"
                  style={{ width: "60px", height: "36px", fontSize: "20px" }}
                  onClick={() => {
                    this.AddDataTable2();
                    this.setState({ show1: false });
                  }}
                >
                  {" "}
                  ใช่{" "}
                </Button>
                <Button
                  variant="primary"
                  style={{ width: "60px", height: "36px", fontSize: "20px" }}
                  onClick={() => {
                    this.setState({ show1: false });
                  }}
                >
                  {" "}
                  ไม่ใช่{" "}
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <div className="PSAppTable">
            <BootstrapTable
              data={this.state.products}
              // trClassName="trClassName"
              // tableHeaderClass="trClassName"
              options={{ noDataText: "...", onRowClick: this.onRowClick }}
              cellEdit={{
                mode: "click",
                blurToSave: true,
                beforeSaveCell: this.onBeforeSaveCell,
                afterSaveCell: this.onAfterSaveCell,
              }}
              // keyBoardNav={{ enterToEdit: true }}
              height="400"
            >
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="C0"
                isKey
                width="35"
                dataAlign="center"
                dataFormat={this._chkload.bind(this)}
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                editable={this.state.sEnableedit}
                headerAlign="center"
                className="colbuttomhidden"
              >
                {" "}
                <div align="center"> รหัสสินค้า </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="productcode"
                editable={this.state.col1}
                dataAlign="left"
                width="150"
                columnTitle
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="Btn1"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._productcodeButton.bind(this)}
                columnClassName="columnClassNameFormat1"
              >
                {" "}
                <i id="TableLoadItem" style={{ fontSize: "10px" }}></i>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="productname"
                editable={false}
                dataAlign="left"
                width="200"
                columnTitle
              >
                {" "}
                <div align="center"> ชื่อสินค้า </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                dataAlign="center"
                width="100"
              >
                {" "}
                <div align="center"> คลัง </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="warehouse"
                editable={this.state.col}
                dataAlign="center"
                width="80"
                columnTitle
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="btn_C3"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton_btn_C3.bind(this)}
                columnClassName="columnClassNameFormat1"
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                colSpan="2"
                dataAlign="center"
                className="colbuttomhidden"
                width="100"
              >
                {" "}
                <div align="center"> ตำแหน่งเก็บ </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="location"
                editable={this.state.col}
                dataAlign="center"
                width="80"
                columnTitle
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="1"
                dataField="btn_C4"
                editable={false}
                dataAlign="center"
                width="30"
                dataFormat={this._cellButton_btn_C4.bind(this)}
                columnClassName="columnClassNameFormat1"
              ></TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="unitname"
                editable={false}
                dataAlign="center"
                width="90"
                columnTitle
              >
                {" "}
                <div align="center"> หน่วยนับ </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="quantity"
                editable={this.state.col}
                dataAlign="center"
                width="90"
                columnTitle
              >
                {" "}
                <div align="center"> ปริมาณ </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="saleprice"
                editable={
                  localStorage.getItem("Editamountpermision") === "0"
                    ? false
                    : true
                }
                dataAlign="right"
                width="90"
              >
                {" "}
                <div align="center"> ราคาขาย </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="discountword"
                editable={this.state.reduce}
                dataAlign="right"
                width="90"
                columnTitle
              >
                {" "}
                <div align="center"> ลด </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="discountamount"
                editable={false}
                dataAlign="right"
                width="90"
              >
                {" "}
                <div align="center"> จำนวนเงิน(ส่วนลด) </div>{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="amount"
                editable={false}
                dataAlign="right"
                width="90"
              >
                <div align="center" columnTitle>
                  {" "}
                  จำนวนเงิน{" "}
                </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="refdocno"
                editable={false}
                dataAlign="center"
                width="100"
              >
                <div align="center" columnTitle>
                  {" "}
                  อ้างอิง{" "}
                </div>
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="productgroup"
                rowSpan="2"
                width="90"
                editable={false}
                hidden
              >
                productgroup
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="refLineID"
                width="90"
                editable={false}
                hidden
              >
                refLineID{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                dataField="unitcode"
                width="90"
                editable={false}
                hidden
              >
                unitcode{" "}
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="stocktype"
                width="90"
                editable={false}
                hidden
              >
                stocktype
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="itemtaxtype"
                width="90"
                editable={false}
                hidden
              >
                itemtaxtype
              </TableHeaderColumn>
              <TableHeaderColumn
                row="0"
                rowSpan="2"
                dataField="productset"
                width="90"
                editable={false}
                hidden
              >
                productset
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          {/* กลุ่มที่ 1: ข้อมูลการขายและการชำระเงิน */}
          {/*  Grid ส่วนล่าง*/}
          <Grid
            container
            spacing={1}
            sx={{
              mt: 2,
              width: "100%",
              margin: "16px 0 0 0",
              "& .MuiGrid-item": {
                display: "flex",
                flexDirection: "column",
                "& .form-group": {
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                },
                "& .input-group": {
                  flex: 1,
                  display: "flex",
                  width: "100%",
                },
                "& .form-control": {
                  flex: 1,
                  width: "100%",
                },
              },
            }}
          >
            {/* แถวที่ 1: กลุ่มย่อยที่ 1 และ กลุ่มย่อยที่ 2 */}
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <Grid container spacing={1}>
                {/* กลุ่มย่อยที่ 1: พนักงานขาย, แผนก, สาขา, สกุลเงิน */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">พนักงานขาย</span>
                          <input
                            type="text"
                            className="form-control hidden"
                            ref={this.Csuser_code}
                          />
                          <input
                            type="text"
                            className="form-control"
                            ref={this.Csuser}
                            readOnly
                          />
                          <span id=" " className="input-group-addon icon">
                            <i
                              className="fas fa-sync-alt"
                              onClick={() =>
                                this.onAddValue(
                                  "Csuser",
                                  this.state.siteCodeUser1
                                )
                              }
                            ></i>
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">แผนก</span>
                          <input
                            type="text"
                            className="form-control hidden"
                            ref={this.Department_code}
                          />
                          <input
                            type="text"
                            className="form-control"
                            name="Department"
                            ref={this.Department}
                          />
                          <span
                            id="iconDepartment"
                            className="input-group-addon icon"
                            onClick={this.Switch_OtherPopup.bind(
                              null,
                              "Department"
                            )}
                          >
                            <i>
                              <ArrowDropDownRoundedIcon fontSize="small" />
                            </i>
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">สาขา</span>
                          <input
                            type="text"
                            className="form-control hidden"
                            ref={this.Branch_code}
                          />
                          <input
                            type="text"
                            className="form-control"
                            name="Branch"
                            ref={this.Branch}
                          />
                          <span
                            id="iconBranch"
                            className="input-group-addon icon"
                            onClick={this.Switch_OtherPopup.bind(
                              null,
                              "Branch"
                            )}
                          >
                            <i>
                              {" "}
                              <ArrowDropDownRoundedIcon fontSize="small" />
                            </i>
                          </span>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">สกุลเงิน</span>
                          <input
                            type="text"
                            className="form-control"
                            defaultValue="บาท"
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                {/* กลุ่มย่อยที่ 2: ประเภทการขาย, หักเงินมัดจำ, หัก ณ ที่จ่าย, อัตราแลกเปลี่ยน */}
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group ">
                          <SelectDatas
                            origin="SaleType" // ประเภท
                            valueSelect={(e) =>
                              this.SelectSetData("SaleType", e)
                            } // รับค่ากลับ
                            title="ประเภทการขาย"
                            defaultselect={this.state.defaultselect} // ค่าเริ่มต้นของ ประเภทราคา
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            หักเงินมัดจำ
                          </span>
                          <input
                            type="number"
                            className="form-control"
                            ref={this.depositpayment}
                            readOnly
                            tabIndex={5}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            หัก ณ ที่จ่าย
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            ref={this.WTAXAMOUNT}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            อัตราแลกเปลี่ยน
                          </span>
                          <input
                            type="text"
                            className="form-control Price"
                            value="1.0000000"
                            readOnly
                          />
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* แถวที่ 2: หมายเหตุ และ โครงการ*/}
              <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="form-group input-Bottom">
                      <div className="input-group">
                        <span className="input-group-addon">หมายเหตุ</span>
                        <input
                          type="text"
                          className="form-control"
                          ref={this.REMARK}
                          tabIndex={6}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                    <div className="form-group input-Bottom">
                      <div className="input-group">
                        <SelectDatas
                          origin="PROJECT" // โครงการ
                          valueSelect={(e) => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                          title="โครงการ"
                          defaultselect={this.state.PROJECT} // ค่าเริ่มต้นของ โครงการ
                        />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* กลุ่มที่ 2: สรุปยอดเงิน */}
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-group input-Bottom">
                    <div className="input-group">
                      <span className="input-group-addon">รวมจำนวนเงิน</span>
                      <input
                        type=""
                        className="form-control Price"
                        ref={this.SumPrice}
                        readOnly
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-group input-Bottom">
                    <div className="input-group">
                      <span className="input-group-addon">ส่วนลด</span>
                      <input
                        type="text"
                        min="1"
                        max="100"
                        className="form-control Price"
                        ref={this.Discountinput}
                        onClick={(e) => {
                          e.target.value = parseFloat(e.target.value).toFixed(
                            0
                          );
                        }}
                        onKeyDown={this.Cal_Price1}
                        onBlur={this.Cal_Price.bind(null)}
                      />
                      <span className="input-group-addon icon">
                        <i className="fas fa-percentage"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.Discount}
                        readOnly
                        tabIndex={4}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-group input-Bottom">
                    <div className="input-group">
                      <span className="input-group-addon">มูลค่าสินค้า</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.ProductValue}
                        readOnly
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-group input-Bottom">
                    <div className="input-group">
                      <span className="input-group-addon">ภาษีมูลค่าเพิ่ม</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.TaxPersen}
                        onClick={(e) => {
                          e.target.value = parseFloat(e.target.value).toFixed(
                            0
                          );
                        }}
                        onKeyDown={this.Cal_Price1}
                        onBlur={this.Cal_Price.bind(null)}
                      />
                      <span className="input-group-addon icon">
                        <i className="fas fa-percentage"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.TaxPrice}
                        readOnly
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-group input-Bottom">
                    <div className="input-group">
                      <span className="input-group-addon ">มูลค่ารวมภาษี</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.valueTax}
                        readOnly
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-group input-Bottom">
                    <div className="input-group">
                      <span className="input-group-addon"> มูลค่ายกเว้น</span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.ValueExcept}
                        readOnly
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="form-group input-Bottom">
                    <div className="input-group">
                      <span className="input-group-addon">
                        {" "}
                        รวมเงินทั้งสิ้น
                      </span>
                      <input
                        type="text"
                        className="form-control Price"
                        ref={this.TotalPrice}
                        readOnly
                      />
                      {/* <span className="input-group-addon icon" onClick={this.Cal_Price.bind(null)}>
                      <i className="fas fa-calculator"></i>
                    </span> */}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Card sx={{ mt: 2, boxShadow: 3 }}>
                <CardHeader
                  title={
                    <Typography
                      variant="h6"
                      component="h5"
                      sx={{ fontWeight: "bold" }}
                    >
                      ข้อมูลเพิ่มเติม ( User's Field )
                    </Typography>
                  }
                  sx={{
                    backgroundColor: "#f5f5f5",
                    borderBottom: "1px solid #e0e0e0",
                  }}
                />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            รหัสลูกค้าจริง
                          </span>
                          <input
                            type="text"
                            className="form-control Price"
                            ref={this.ArCode2}
                            tabIndex={7}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">ดอกเบี้ย</span>
                          <input
                            type="text"
                            className="form-control Price"
                            ref={this.interest}
                            tabIndex={8}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> เงินดาวน์</span>
                          <input
                            type="number"
                            className="form-control Price"
                            ref={this.downpayment}
                            tabIndex={9}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            {" "}
                            จำนวนเงิน*จำนวนงวด
                          </span>
                          <input
                            type="text"
                            className="form-control Price"
                            ref={this.period}
                            tabIndex={9}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            {" "}
                            ค่าคอมมิชชั่น
                          </span>
                          <input
                            type="text"
                            className="form-control Price"
                            ref={this.commissionfee}
                            tabIndex={10}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span
                            className="input-group-addon"
                            title="Tooltip on top"
                          >
                            {" "}
                            ค่าธรรมเนียมสัญญา
                          </span>
                          <input
                            type="text"
                            className="form-control Price"
                            ref={this.contractfee}
                            tabIndex={11}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> คูปอง</span>
                          <input
                            type="text"
                            ref={this.coupon}
                            className="form-control"
                            tabIndex={12}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> ของแถม</span>
                          <input
                            type="text"
                            className="form-control "
                            ref={this.FreeGift}
                            tabIndex={13}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> เลขที่ PDI</span>
                          <input
                            type="text"
                            className="form-control Price"
                            ref={this.pdinumber}
                            tabIndex={14}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> เลขไมล์</span>
                          <input
                            type="number"
                            className="form-control"
                            ref={this.mileageNumber}
                            tabIndex={15}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            {" "}
                            เลขเครื่อง:{" "}
                          </span>
                          <input
                            type="text"
                            className="form-control "
                            ref={this.machineNumber}
                            tabIndex={16}
                          />
                          {/* <span className="input-group-addon icon" ><i className="fas fa-calculator"></i></span> */}
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon">
                            {" "}
                            หมายเลขตัวถัง
                          </span>
                          <input
                            type="text"
                            className="form-control "
                            ref={this.MTSerialNo}
                            tabIndex={17}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <div className="input-group ">
                        <SelectDatas
                          origin="checkkm" // ประเภท
                          valueSelect={(e) => this.SelectSetData("checkkm", e)} // รับค่ากลับ
                          title="เช็คระยะ"
                          defaultselect={this.state.CheckKilometer} // ค่าเริ่มต้นของ ประเภทราคา
                        />
                      </div>

                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> ยี่ห้อ</span>
                          <AsyncTypeahead
                            id="my-typeahead-id"
                            {...this.state}
                            labelKey="brandname"
                            onChange={(selectedbrandname) =>
                              this.setState({ selectedbrandname })
                            }
                            onBlur={this._blurinput}
                            onSearch={this._handleSearch}
                            minLength={1}
                            placeholder="ค้นหายี่ห้อ..."
                            renderMenuItemChildren={(option, props0) => (
                              <MenuItem key={option}> {option} </MenuItem>
                            )}
                            onFocus={() =>
                              this.setState({ chkfocus: "brandname" })
                            }
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> รุ่นรถ</span>
                          <AsyncTypeahead
                            id="my-typeahead-id1"
                            {...this.state}
                            labelKey="model"
                            onChange={(selectedmodel) =>
                              this.setState({ selectedmodel })
                            }
                            onBlur={this._blurinput}
                            onSearch={this._handleSearch}
                            minLength={1}
                            placeholder="ค้นหารุ่น..."
                            renderMenuItemChildren={(option, props) => (
                              <MenuItem key={option}> {option} </MenuItem>
                            )}
                            onFocus={() => this.setState({ chkfocus: "model" })}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> สีรถ</span>
                          <AsyncTypeahead
                            id="my-typeahead-id2"
                            {...this.state}
                            labelKey="color"
                            onChange={(selectedcolor) =>
                              this.setState({ selectedcolor })
                            }
                            onBlur={this._blurinput}
                            onSearch={this._handleSearch}
                            minLength={1}
                            placeholder="ค้นหาสี..."
                            renderMenuItemChildren={(option, props) => (
                              <MenuItem key={option}> {option} </MenuItem>
                            )}
                            onFocus={() => this.setState({ chkfocus: "color" })}
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom">
                        <div className="input-group">
                          <span className="input-group-addon"> ทะเบียน</span>
                          <input
                            type="text"
                            className="form-control"
                            ref={this.Rnregist}
                            tabIndex={22}
                          />
                        </div>
                      </div>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={4}>
                        <CustomInput
                          label="ค่าตรวจ ตรอ."
                          onBlur={(e) => {
                            this.setState({ Check_Status: e });
                          }}
                          inputType={"text"}
                          defaultValue={""}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          label="เลขที่รับมัดจำ"
                          onBlur={(e) => {
                            this.setState({ Deposit_No: e });
                          }}
                          inputType={"text"}
                          defaultValue={""}
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <CustomInput
                          label="ค่าประกันรถหาย"
                          onBlur={(e) => {
                            this.setState({ carinsurance: e });
                          }}
                          inputType={"number"}
                          defaultValue={""}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Snackbar
            place="br"
            color={this.state.color}
            icon={this.state.icon}
            autoClose={this.state.autoClose}
            message={this.state.messagealert}
            open={this.state.opensnackbar}
            closeNotification={() => {
              this.setState({ opensnackbar: false });
            }}
            close
          />
        </div>
      </div>
    );
  }
}
